import React from "react";
import { PDFDocument } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from 'react-phone-number-input';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import moment from 'moment';
import Loader from "react-loader-spinner";
import { useState, useEffect, useRef } from "react";
import Alert from "@material-ui/lab/Alert";
import {
  Label,
  CustomInput,
  Collapse,
  Input,
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { IconButton } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

import {
  allAssetDebitData,
  postAssetDebitData,
  employementDetails,
  taxInformation,
  ageEducation,
  otherPartyIncome,
  income,
  investIncome,
  additionalIncome,
  selfEmployeedIncome,
  changeInIncome,
  deductions,
  asset,
  averageMonthallyExpenset,
  attorneyFee,
  numberOfChildren,
  childHealthExpenses,
  childAdditionalExpenses,
  specialHardship,
  otherInformation,
  peopleLiveCall,
  installmentPaymentsCall,
  deletePeopleLiveCall,
  deleteInstallmentCall,
} from "./assestDebit.actions";
import { getStates } from "../../../profileInformation/profileInformation.actions";
import { isEmpty, isUndefined, filter, size, remove, forEach, get } from 'lodash';
import { serverApi ,parseDate } from '../../../../../../global/globalFunctions';
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const AssestsDebits = (props) => {
  const [fileTax, setfileTax] = useState(props.taxInData.taxReturnState == "1" ? 1 : -1);
  const [state, setState] = useState(props.taxInData.californiaState == "1" ? 1 : -1);
  const [selfEmployment, setSelfEmployment] = useState(false);
  const [isMortgage, setIsMortgage] = useState(props.homeStatus.rent == "0" ? 0 : props.homeStatus.rent == "1" ? 1 : -1);
  const [isRent, setIsRent] = useState("1");
  const [isRequesting, setIsRequesting] = useState(props.attorneyFees.no == "1" ? 1 : -1);
  const [spouseName, setSpouseName] = useState(props.taxInData.taxFilingStatus == "3" ? 3 : -1);
  const [healthInsurance, setHealthInsurance] = useState(props.childHealthCareExpense.no == "1" ? 1 : -1);
  const [salaryType, setSalaryType] = useState("1");
  const [ReceivingSS, setReceivingSS] = useState("1");
  const [ReceivingPS, setReceivingPS] = useState("1");
  const [disability, setDisability] = useState("1");
  const [value, setValue] = useState(0);

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);


  const [spousalCB, setSpousalCB] = useState([]);
  const [partnerCB, setPartnerCB] = useState([]);
  const [disabilityCB, setDisabilityCB] = useState([]);
  const [monthallyCB, setMonthallyCB] = useState([]);


  function boxesSpousal(value) {
    if (spousalCB.includes(value)) {
      let dummyArray1 = spousalCB;
      remove(dummyArray1, function (val) {
        return val === value;
      });
    } else {
      let dummyArray1 = spousalCB;
      dummyArray1.push(value);
      setSpousalCB(dummyArray1);
    }
  }

  const arrayCBOne = () => {
    let cb = [];
    forEach([1, 2, 3], (y) => {
      let z = !isEmpty(props.incomeSpousalSuport.spousalSuportCheck) && (props.incomeSpousalSuport.spousalSuportCheck).includes(`${y}`)
      z == true && cb.push(z == true ? `${y}` : "");
    });
    setSpousalCB(cb)
  }

  function boxesPartner(value) {
    if (partnerCB.includes(value)) {
      let dummyArray1 = partnerCB;
      remove(dummyArray1, function (val) {
        return val === value;
      });
    } else {
      let dummyArray1 = partnerCB;
      dummyArray1.push(value);
      setPartnerCB(dummyArray1);
    }
  }

  const arrayCBTwo = () => {
    let cb = [];
    forEach([1, 2], (y) => {
      let z = !isEmpty(props.incomePartnerSupport.partnerSupportCheck) && (props.incomePartnerSupport.partnerSupportCheck).includes(`${y}`)
      z == true && cb.push(z == true ? `${y}` : "");
    });
    setPartnerCB(cb)
  }

  function boxesDisability(value) {
    if (disabilityCB.includes(value)) {
      let dummyArray1 = disabilityCB;
      remove(dummyArray1, function (val) {
        return val === value;
      });
    } else {
      let dummyArray1 = disabilityCB;
      dummyArray1.push(value);
      setDisabilityCB(dummyArray1);
    }
  }

  const arrayCBThree = () => {
    let cb = [];
    forEach([1, 2, 3], (y) => {
      let z = !isEmpty(props.incomeDisability.disabilityCheck) && (props.incomeDisability.disabilityCheck).includes(`${y}`)
      z == true && cb.push(z == true ? `${y}` : "");
    });
    setDisabilityCB(cb)
  }

  function boxesMonthally(value) {
    if (monthallyCB.includes(value)) {
      let dummyArray1 = monthallyCB;
      remove(dummyArray1, function (val) {
        return val === value;
      });
    } else {
      let dummyArray1 = monthallyCB;
      dummyArray1.push(value);
      setMonthallyCB(dummyArray1);
    }
  }

  const arrayCBFour = () => {
    let cb = [];
    forEach([1, 2, 3], (y) => {
      let z = !isEmpty(props.homeStatus.averageMonthlyExpenseBox) && (props.homeStatus.averageMonthlyExpenseBox).includes(`${y}`)
      z == true && cb.push(z == true ? `${y}` : "");
    });
    setMonthallyCB(cb)
  }


  async function myFunction() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-150`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());
    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const form = pdfDoc.getForm();

    const petitionerDetails = props.petitioner;
    const respondentDetails = props.respondent;
    const courtDetails = props.court;


    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);

    if (props.petitionerCheck == 0) {
      !isEmpty(petState) && form.getField("state").setText(petState[0].state_name);
      !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
      !isUndefined(petitionerDetails) && form.getField("zipCode").setText(petitionerDetails.zip);
      !isUndefined(petitionerDetails) && form.getField("telePhone").setText(petitionerDetails.telephone);
      !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);
      !isUndefined(petitionerDetails) && form.getField("streetAddress").setText(petitionerDetails.streetAddress);
      !isUndefined(petitionerDetails) && form.getField("city").setText(petitionerDetails.city);
      !isUndefined(petitionerDetails) && form.getField("taxName").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
      !isUndefined(petitionerDetails) && form.getField("amountName").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);

    } else {
      !isEmpty(resState) && form.getField("state").setText(resState[0].state_name);
      !isUndefined(respondentDetails) && form.getField("name").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
      !isUndefined(respondentDetails) && form.getField("zipCode").setText(respondentDetails.zip);
      !isUndefined(respondentDetails) && form.getField("telePhone").setText(respondentDetails.telephone);
      !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email);
      !isUndefined(respondentDetails) && form.getField("streetAddress").setText(respondentDetails.streetAddress);
      !isUndefined(respondentDetails) && form.getField("city").setText(respondentDetails.city);
      !isUndefined(petitionerDetails) && form.getField("taxName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
      !isUndefined(petitionerDetails) && form.getField("amountName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);

    }


    !isUndefined(courtDetails) && form.getField("courtAddress").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("cityZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
    !isUndefined(courtDetails) && form.getField("superiorCourt").setText(courtDetails.county);
    !isUndefined(courtDetails) && form.getField("branchName").setText(courtDetails.branchName);


    !isUndefined(respondentDetails) && form.getField("courtRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("courtPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    form.getField("caseNumber").setText(courtDetails.caseNumber.toString());

    !isUndefined(respondentDetails) && form.getField("taxRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("taxPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    form.getField("taxCaseNum").setText(courtDetails.caseNumber.toString());

    !isUndefined(respondentDetails) && form.getField("assetRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("assetPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    form.getField("assetCaseNum").setText(courtDetails.caseNumber.toString());

    !isUndefined(respondentDetails) && form.getField("amountRespondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("amountPetitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    form.getField("amountCaseNumber").setText(courtDetails.caseNumber.toString());




    //Employement Details

    form.getField("empLoye").setText(props.employement.employer);
    form.getField("empAddress").setText(props.employement.address);
    form.getField("empPhone").setText(props.employement.phoneNumber);
    form.getField("empOccupation").setText(props.employement.occupation);
    form.getField("dateJobStart").setText(props.employement.jobStartedDate == "1947-01-01" ? "" : parseDate(props.employement.jobStartedDate));
    form.getField("dateJobEnd").setText(props.employement.jobEndedDate == "1947-01-01" ? "" : parseDate(props.employement.jobEndedDate));
    form.getField("hourPerWeek").setText(props.employement.workingHoursWeekly);
    form.getField("grossPaid").setText(props.employement.paidGross.toString());

    if (props.employement.salaryType == "1") {
      form.getCheckBox("grossPerMonth").check();
    }
    else if (props.employement.salaryType == "2") {
      form.getCheckBox("grossPerWeek").check();
    }
    else if (props.employement.salaryType == "3") {
      form.getCheckBox("grossPerDay").check();
    } else {
      form.getCheckBox("grossPerMonth").uncheck();
      form.getCheckBox("grossPerWeek").uncheck();
      form.getCheckBox("grossPerDay").uncheck();

    }


    if (monthallyCB.includes("1")) {
      form.getCheckBox("selfBus").check();

    }
    if (monthallyCB.includes("2")) {
      form.getCheckBox("businessPartner").check();

    }
    if (monthallyCB.includes("3")) {
      form.getCheckBox("selfOther").check();

    }




    //Age and education

    form.getField("myAge").setText(props.ageAndEducation.age.toString());
    form.getField("collegeYear").setText(props.ageAndEducation.NumberOfYearsCollege.toString());
    form.getField("schoolYear").setText(props.ageAndEducation.NumberOfYearsGraduates.toString());

    if (props.ageAndEducation.specifyCollegeDegree !== "") {
      form.getCheckBox("degreeObt").check();
      form.getField("degreeSpec").setText(props.ageAndEducation.specifyCollegeDegree.toString());
    }

    if (props.ageAndEducation.specifyGraduateDegree !== "") {
      form.getCheckBox("schoolDegree").check();
      form.getField("degreeSpecify").setText(props.ageAndEducation.specifyGraduateDegree.toString());
    }



    if (props.ageAndEducation.isHighSchoolDegreeCompleted == "1") {
      form.getCheckBox("highSchoolYes").check();

    }
    else if (props.ageAndEducation.isHighSchoolDegreeCompleted == "0") {
      form.getCheckBox("HighSchoolNo").check();

    }
    else {
      form.getCheckBox("highSchoolYes").uncheck();
      form.getCheckBox("HighSchoolNo").uncheck();
    }

    if (form.getCheckBox("HighSchoolNo").isChecked()) {
      form.getField("highestGrade").setText();
    }

    if (!isEmpty(props.ageAndEducation.professionalOccupational)) {
      form.getField("profLicenseSpec").setText(props.ageAndEducation.professionalOccupational);
      form.getCheckBox("proLicense").check();
    } else {
      form.getField("profLicenseSpec").setText("");
      form.getCheckBox("proLicense").uncheck();
    }



    if (!isEmpty(props.ageAndEducation.vocationalTraining)) {
      form.getCheckBox("vocarionalTrain").check();
      form.getField("vocarionalTrainSpec").setText(props.ageAndEducation.vocationalTraining);
    } else {
      form.getCheckBox("vocarionalTrain").uncheck();
      form.getField("vocarionalTrainSpec").setText("");

    }

    //  TAX INFORMATION   

    if (props.taxInData.lastTaxYear !== "") {
      form.getCheckBox("taxInfo").check();
      form.getField("taxYear").setText(props.taxInData.lastTaxYear.toString());
    }

    if (props.taxInData.taxFilingStatus == "0") {
      form.getCheckBox("taxfillng").check();
    } else if (props.taxInData.taxFilingStatus == "1") {
      form.getCheckBox("taxFillHead").check();
    } else if (props.taxInData.taxFilingStatus == "2") {
      form.getCheckBox("taxFillMarried").check();
    } else if (props.taxInData.taxFilingStatus == "3") {
      form.getCheckBox("taxSeparate").check();
    } else {
      form.getCheckBox("taxfillng").uncheck();
      form.getCheckBox("taxFillHead").uncheck();
      form.getCheckBox("taxFillMarried").uncheck();
      form.getCheckBox("taxSeparate").uncheck();
    }

    if (form.getCheckBox("taxSeparate").isChecked()) {
      form.getField("fillingSpecName").setText(props.taxInData.spouseName);

    } else {
      form.getField("fillingSpecName").setText("");
    }

    if (props.taxInData.taxReturnState == "0") {
      form.getCheckBox("stateTax").check();
    }
    else {
      form.getCheckBox("stateTax").uncheck();
    }

    if (props.taxInData.taxReturnState == "1") {
      form.getCheckBox("stateother").check();
    }
    else {
      form.getCheckBox("stateother").uncheck();
    }
    if (form.getCheckBox("stateother").isChecked()) {
      form.getField("stateOtherSpec").setText(props.taxInData.outSideCalifornia);
    }

    form.getField("claimTax").setText(props.taxInData.exemptionsOnTax.toString());


    //Other Party Income 
    form.getField("otherPartyIncome").setText(props.otherPartyData.grossMonthallyIncome.toString());
    form.getField("estimatBase").setText(props.otherPartyData.estimateBasedOn);

    //Income
    form.getField("salaryLast").setText(props.incomeSalaryWages.lastMonth.toString());
    form.getField("salaryMonthly").setText(props.incomeSalaryWages.averageMonthally.toString());
    //      
    form.getField("lastMonthTime").setText(props.incomeOverTime.lastMonth.toString());
    form.getField("monthlyOvertime").setText(props.incomeOverTime.averageMonthally.toString());
    //        
    form.getField("bonusLast").setText(props.incomeCommissions.lastMonth.toString());
    form.getField("monthlybonus").setText(props.incomeCommissions.averageMonthally.toString());
    //           
    !isUndefined(props.incomePublicAssistance.currentlyReceivingCheck) && props.incomePublicAssistance.currentlyReceivingCheck == "1" ? form.getCheckBox("pubAssistance").check() : form.getCheckBox("pubAssistance").uncheck();
    form.getField("PubAssistLast").setText(props.incomePublicAssistance.lastMonth.toString());
    form.getField("monthlyPubAssist").setText(props.incomePublicAssistance.averageMonthally.toString());

    if (spousalCB.includes("1")) {
      form.getCheckBox("spoualSupport").check();
    } if (spousalCB.includes("2")) {
      form.getCheckBox("spousalMarriage").check();
    } if (spousalCB.includes("3")) {
      form.getCheckBox("spoDiffMarriage").check();
    }

    form.getField("spousalLast").setText(props.incomeSpousalSuport.lastMonth.toString());
    form.getField("monthlySpousal").setText(props.incomeSpousalSuport.averageMonthally.toString());


    if (partnerCB.includes("1")) {
      form.getCheckBox("partnerSupport").check();
    } if (partnerCB.includes("2")) {
      form.getCheckBox("domesticPartner").check();
    }

    form.getField("partSupLast").setText(props.incomePartnerSupport.lastMonth.toString());
    form.getField("monthlyPartSup").setText(props.incomePartnerSupport.averageMonthally.toString());
    //
    form.getField("fundPayLast").setText(props.incomePensionRetirementFund.lastMonth.toString());
    form.getField("monthlyFundPay").setText(props.incomePensionRetirementFund.averageMonthally.toString());
    //

    form.getField("socialLast").setText(props.incomeSocialSecurity.lastMonth.toString());
    form.getField("monthlySocial").setText(props.incomeSocialSecurity.averageMonthally.toString());
    //

    form.getField("disAbilityLast").setText(props.incomeDisability.lastMonth.toString());
    form.getField("monthlydisability").setText(props.incomeDisability.averageMonthally.toString());


    if (disabilityCB.includes("1")) {
      form.getCheckBox("disAbility").check();
    } if (disabilityCB.includes("2")) {
      form.getCheckBox("socialSec").check();
    } if (disabilityCB.includes("3")) {
      form.getCheckBox("privateInsurance").check();
    }

    //
    form.getField("unEmpLast").setText(props.incomeUnemploymentCompensation.lastMonth.toString());
    form.getField("monthlyUnemp").setText(props.incomeUnemploymentCompensation.averageMonthally.toString());
    //       
    form.getField("workerLast").setText(props.incomeWorkerCompensation.lastMonth.toString());
    form.getField("monthlyWork").setText(props.incomeWorkerCompensation.averageMonthally.toString());
    //       
    form.getField("taxOtherSpecify").setText(props.incomeOthers.specific);
    form.getField("othersLast").setText(props.incomeOthers.lastMonth.toString());
    form.getField("monthlyOther").setText(props.incomeOthers.averageMonthally.toString());

    //

    form.getField("diviDentLast").setText(props.dividendsInterest.lastMonth.toString());
    form.getField("monthDividend").setText(props.dividendsInterest.averageMonthally.toString());
    //       
    form.getField("rentelLast").setText(props.rentalPropertyIncome.lastMonth.toString());
    form.getField("monthlyRentel").setText(props.rentalPropertyIncome.averageMonthally.toString());
    //       
    form.getField("trustLast").setText(props.workerCompensation.lastMonth.toString());
    form.getField("monthlyLast").setText(props.workerCompensation.averageMonthally.toString());
    //       
    form.getField("InvestOther").setText(props.trustIncome.specific);
    form.getField("investLast").setText(props.trustIncome.lastMonth.toString());
    form.getField("monthlyInvest").setText(props.trustIncome.averageMonthally.toString());
    //       

    if (props.oneTimeMoney.specific !== "") {
      form.getCheckBox("additionalIncome").check();
      form.getField("oneTimeMoney").setText(props.oneTimeMoney.specific.toString());
    } else {
      form.getCheckBox("additionalIncome").uncheck();
      form.getField("oneTimeMoney").setText("");
    }


    !isEmpty(inputFields) && inputFields.map((people, index) => {
      people.household_expenses == "1" ? form.getCheckBox(`payYes${index}`).check() :
        people.household_expenses == "0" ? form.getCheckBox(`payNo${index}`).check() : (form.getCheckBox(`payNo${index}`).uncheck() && form.getCheckBox(`payYes${index}`).uncheck())
      form.getField(`OneName${index}`).setText(people.name);
      form.getField(`oneAge${index}`).setText(people.age.toString());
      form.getField(`personRelOne${index}`).setText(people.person_related);
      form.getField(`monthlyIncome${index}`).setText(people.person_monthly_income.toString());
    });

    !isEmpty(inputFieldsInstallment) && inputFieldsInstallment.map((expense, index) => {
      form.getField(`Paid${index}`).setText(expense.toPaymentInstallment.toString());
      form.getField(`paidFor${index}`).setText(expense.forPaymentInstallment);
      form.getField(`amount${index}`).setText(expense.amountInstallment.toString());
      form.getField(`balance${index}`).setText(expense.balanceInstallment.toString());
      form.getField(`dolPay${index}`).setText(expense.dateLastInstallment == "1947-01-01" ? "" :parseDate(expense.dateLastInstallment));
    });

    //

    if (props.selfEmploymentType == "0") {
      form.getCheckBox("selfBus").check();
    } else if (props.selfEmploymentType == "1") {
      form.getCheckBox("businessPartner").check();
    } else if (props.selfEmploymentType == "2") {
      form.getCheckBox("selfOther").check();
    }
    else {
      form.getCheckBox("selfBus").uncheck();
      form.getCheckBox("businessPartner").uncheck();
      form.getCheckBox("selfOther").uncheck();
    }
    if (form.getCheckBox("selfOther").isChecked()) {
      form.getField("selfEmpOther").setText(props.selfEmploymentSpecify.toString());
    }
    form.getField("noOfYear").setText(props.selfEmploymentBusinessYears.toString());
    form.getField("nameOfBusiness").setText(props.selfEmploymentBusinessName.toString());
    form.getField("typeOfBusiness").setText(props.selfEmploymentBusinessType.toString());

    //
    if (props.changeInMoney !== "") {
      form.getCheckBox("changeIncome").check();
      form.getField("changeSign").setText(props.changeInMoney.toString());
    } else {
      form.getCheckBox("changeIncome").uncheck();
      form.getField("changeSign").setText("");
    }

    //
    form.getField("infoChild").setText(props.childrenSpecify);


    form.getField("unionDuesLast").setText(props.requiredUnionDues.lastMonth.toString());
    form.getField("reqPaymentLast").setText(props.requiredRetirementPay.lastMonth.toString());
    form.getField("tmaLast").setText(props.healthExpenses.lastMonth.toString());
    form.getField("childSupLast").setText(props.childSupport.lastMonth.toString());
    form.getField("PartnerSupportLast").setText(props.partnerSupport.lastMonth.toString());
    if (props.spousalSupport.federallytax == 1) {
      form.getCheckBox("spoasalSup").check();
    }

    if (props.spousalSupport.lastMonth !== "") {
      form.getField("deductLast").setText(props.spousalSupport.lastMonth.toString());
    } else {
      form.getField("deductLast").setText("");
    }
    form.getField("jobRelatedLast").setText(props.jobExpenses.lastMonth.toString());

    //
    form.getField("cashAssetTotal").setText(props.accounts.lastMonth.toString());
    form.getField("assetsSellTotal").setText(props.stockBonds.lastMonth.toString());
    if (props.otherPropert.type == "0") {
      form.getCheckBox("assetProperty").check();
    } else if (props.otherPropert.type == "1") {
      form.getCheckBox("assetPersonal").check();
    } else if (props.otherPropert.type == "2") {
      form.getCheckBox("assetProperty").check();
      form.getCheckBox("assetPersonal").check();
    } else {
      form.getCheckBox("assetProperty").uncheck();
      form.getCheckBox("assetPersonal").uncheck();
    }
    if (form.getCheckBox("assetProperty").isChecked() || form.getCheckBox("assetPersonal").isChecked()) {
      form.getField("assetOtherTotal").setText(props.otherPropert.lastMonth.toString());
    } else {
      form.getField("assetOtherTotal").setText("");
    }

    form.getField("homeTotalExp").setText(props.totalExpense.toString());
    form.getField("amountOfExpense").setText(props.amountPaidByOthers.toString());

    let cb = !isEmpty(props.homeStatus.averageMonthlyExpenseBox) && size(props.homeStatus.averageMonthlyExpenseBox.find(x => x === '1'))
    !isUndefined(cb) && cb == "1" && form.getCheckBox("estimateExpense").check()
    let cbExp = !isEmpty(props.homeStatus.averageMonthlyExpenseBox) && size(props.homeStatus.averageMonthlyExpenseBox.find(x => x === '2'))
    !isUndefined(cbExp) && cbExp == "1" && form.getCheckBox("actExpense").check()
    let cbPro = !isEmpty(props.homeStatus.averageMonthlyExpenseBox) && size(props.homeStatus.averageMonthlyExpenseBox.find(x => x === '3'))
    !isUndefined(cbPro) && cbPro == "1" && form.getCheckBox("proExpense").check()


    //
    if (props.homeStatus.rent == "0") {
      form.getCheckBox("homeMortage").check();
    } else if (props.homeStatus.rent == "1") {
      form.getCheckBox("morTgage").check();
    } else {
      form.getCheckBox("homeMortage").uncheck();
      form.getCheckBox("morTgage").uncheck();
    }

    if (form.getCheckBox("homeMortage").isChecked()) {
      form.getField("homePay").setText(props.homeStatus.rental.rentalCost.toString());
    } else {
      form.getField("homePay").setText("");
    }
    const sumMortgage = Number(props.homeStatus.mortgage.averagePrincipal) + Number(props.homeStatus.mortgage.averageIntrest);
    if (form.getCheckBox("morTgage").isChecked()) {
      form.getField("homePay").setText(sumMortgage.toString());
      form.getField("avePrincipal").setText(props.homeStatus.mortgage.averagePrincipal.toString());
      form.getField("aveInterest").setText(props.homeStatus.mortgage.averageIntrest.toString());
    } else {
      form.getField("avePrincipal").setText("");
      form.getField("aveInterest").setText("");
    }

    form.getField("realProPay").setText(props.realPropertyTax.lastMonth.toString());
    form.getField("renterPay").setText(props.homeOwnerInsurance.lastMonth.toString());
    form.getField("homeRepairPay").setText(props.maintainance.lastMonth.toString());
    form.getField("costPay").setText(props.healthCareCost.lastMonth.toString());
    form.getField("childCarePay").setText(props.childCareCost.lastMonth.toString());
    form.getField("groceriesSupPay").setText(props.householdSupplies.lastMonth.toString());
    form.getField("EatingOutPay").setText(props.eatingOut.lastMonth.toString());
    form.getField("homeUtilityPay").setText(props.utilities.lastMonth.toString());
    form.getField("HomeContactPay").setText(props.telephone.lastMonth.toString());
    form.getField("homeLandryPay").setText(props.laundaryCleaning.lastMonth.toString());
    form.getField("homeClothesPay").setText(props.clothes.lastMonth.toString());
    form.getField("homeEducationPay").setText(props.education.lastMonth.toString());
    form.getField("homeVacationPay").setText(props.entertainment.lastMonth.toString());
    form.getField("homeExpenseTranPay").setText(props.transportation.lastMonth.toString());
    form.getField("homeInsurancePay").setText(props.insurance.lastMonth.toString());
    form.getField("homeSavingPay").setText(props.savingsInvestments.lastMonth.toString());
    form.getField("homeContrPay").setText(props.charitableContributions.lastMonth.toString());
    form.getField("homePaymentPay").setText(props.monthallyPayments.lastMonth.toString());


    form.getField("homePayment").setText(props.others.specific.toString());
    !isUndefined(props.others.lastMonth) && form.getField("homePaymentOtherPay").setText(props.others.lastMonth.toString());
    //Function For Plus


    form.getField("noOfChild").setText(props.NoOfChildren.NumberOfunderAgeChild.toString());
    form.getField("childSpend").setText(props.NoOfChildren.timeSpendWithYouPercentage.toString());
    form.getField("noOfTime").setText(props.NoOfChildren.timeSpendWithSpousePercentage.toString());


    if (props.childHealthCareExpense.no == "1") {
      form.getCheckBox("childHealth").check();
    } else if (props.childHealthCareExpense.no == "0") {
      form.getCheckBox("childHealthNot").check();
    } else {
      form.getCheckBox("childHealthNot").uncheck();
      form.getCheckBox("childHealth").uncheck();
    }

    if (form.getCheckBox("childHealth").isChecked()) {
      form.getField("insuranceComp").setText(props.insuranceCompanyName.toString());
      form.getField("insuranceCompCase").setText(props.insuranceCompanyAddress.toString());
      form.getField("childHealthInsurance").setText(props.monthallyCost.toString());
    }
    else {
      form.getField("insuranceComp").setText("");
      form.getField("insuranceCompCase").setText("");
      form.getField("childHealthInsurance").setText("");
    }

    if (props.attorneyFees.no == "1") {
      form.getField("amountSpec").setText(props.attorneyMonthallyFees.lastMonth.toString())
      form.getField("somSpec").setText(props.sourceOfMoney.toString());
      form.getField("attorneySpec").setText(props.totalOwedFee.lastMonth.toString());
      form.getField("hrSpec").setText(props.attorneyHourlyRate.lastMonth.toString());
    } else {
      form.getField("amountSpec").setText("");
      form.getField("somSpec").setText("");
      form.getField("attorneySpec").setText("");
      form.getField("hrSpec").setText("");
    }

    //
    form.getField("aomOne").setText(props.additionalChildExpense.childCare.toString());
    form.getField("aomTwo").setText(props.additionalChildExpense.childHealthCare.toString());
    form.getField("aomThree").setText(props.additionalChildExpense.childTravelExpense.toString());
    form.getField("aomFour").setText(props.childOtherSpecialNeeds.lastMonth.toString());

    form.getField("specialNeed").setText(props.childOtherSpecialNeeds.specific);

    //
    form.getField("aomFive").setText(props.extraHealthExpenses.lastMonth.toString());
    form.getField("fomOne").setText(props.extraHealthExpenses.averageMonthally.toString());
    form.getField("aomSix").setText(props.majorLoss.lastMonth.toString());
    form.getField("fomTwo").setText(props.majorLoss.averageMonthally.toString());

    form.getField("aomSeven").setText(props.minorChildExpense.lastMonth.toString());
    form.getField("fomThree").setText(props.minorChildExpense.averageMonthally.toString());
    !isUndefined(props.minorCS) && form.getField("childSupPay").setText(props.minorCS.toString());


    !isUndefined(props.financialHardshipExplain) && form.getField("fhCaseNumber").setText(props.financialHardshipExplain);

    //

    !isUndefined(props.otherInfoForCourt) && form.getField("courtCaseNumber").setText(props.otherInfoForCourt);

    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }

  function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }

  useEffect(() => {
    props.getStates();
    props.allAssetDebitData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    })
    props.postAssetDebitData({
      divorce_id: window.localStorage.getItem("divorce_id"),
      userId: window.localStorage.getItem("user_id"),
    });
    arrayCBOne();
    arrayCBTwo();
    arrayCBThree();
    arrayCBFour();
  }, []);



  const selectDisability = (e) => {
    let newState = e.target.id;
    setDisability((prev) => {
      prev = newState;
      return prev;
    }
    );
  }



  const selectReceivingPS = (e) => {
    let newState = e.target.value;
    setReceivingPS((prev) => {
      prev = newState;
      return prev;
    }
    );
  }


  const selectReceivingSS = (e) => {
    let newState = e.target.value;
    setReceivingSS((prev) => {
      prev = newState;
      return prev;
    }
    );
  }

  const selectSalaryType = (e) => {
    let newState = e.target.id;
    setSalaryType((prev) => {
      prev = newState;
      return prev;
    }
    );
  }

  function getSteps() {
    return [
      "Employment",
      "Age and education",
      "Tax Information",
      "Other party's income",
      "Income",
      "Investment income",
      "Additional income I received one-time money (lottery winnings, inheritance, etc.) in the last 12 months",
      "Income from self-employment, after business expenses for all businesses",
      "Change in income",
      "Deductions",
      "Assets",
      "The following people live with me",
      "Average monthly expenses",
      "Installment payments and debts not listed above",
      "Attorney Fees",
      "Number of children",
      "Children's health-care expenses",
      "Additional expense for the children in this case",
      "Special hardships",
      "Other information I want the court to know concerning support in my case",
    ];
  }
  const steps = getSteps();


  const handlePostFunc = () => {
    if (activeStep === 0) {
      props.employementDetails({
        divorce_id: window.localStorage.getItem("divorce_id"),
        employer: document.getElementById("employerFirstName").value,
        address: document.getElementById("employerAddress").value,
        phoneNumber: document.getElementById("employerPhoneNumber").value,
        occupation: document.getElementById("occupation").value,
        jobStartedDate: document.getElementById("dateJobStarted").value,
        jobEndedDate: document.getElementById("dateJobEnded").value,
        workingHoursWeekly: document.getElementById("workPerHour").value,
        paidGross: document.getElementById("getPaid").value,
        salaryType: salaryType,
      });
    } else if (activeStep === 1) {
      props.ageEducation({
        divorce_id: window.localStorage.getItem("divorce_id"),
        age: document.getElementById("age").value,
        highSchoolDegree: document.getElementById("highSchoolDegree").value,
        noOfCollegeYears: document.getElementById("noOfCollegeYears").value,
        noOfGraduateYears: document.getElementById("noOfGraduateYears").value,
        collegeDegreeName: document.getElementById("collegeDegreeName").value,
        garduateDegreeName: document.getElementById("garduateDegreeName").value,
        professionalOccupationalValue: document.getElementById("professionalOccupationalSpecific").value,
        vocationalTrainingValue: document.getElementById("vocationalTrainingSpecific").value,
      });
    } else if (activeStep === 2) {
      props.taxInformation({
        divorce_id: window.localStorage.getItem("divorce_id"),
        taxYear: document.getElementById("taxYear").value,
        taxFilingStatus: document.getElementById("taxFilingStatus").value,
        spouseName: document.getElementById("spouseName").value,
        californiaState: document.getElementById("californiaState").value,
        fileTaxState: document.getElementById("californiaState").value == "1" ? document.getElementById("fileTaxState").value : "-1",
        outSideCalifornia: document.getElementById("californiaState").value == "1" ? document.getElementById("outSideCalifornia").value : "",
        exemptionsOnTaxt: document.getElementById("exemptionsOnTaxt").value,
      });
    } else if (activeStep === 3) {
      props.otherPartyIncome({
        divorce_id: window.localStorage.getItem("divorce_id"),
        otherPartyIncome: document.getElementById("otherPartyIncome").value,
        estimateBasedOn: document.getElementById("estimateBasedOn").value,
      });
    } else if (activeStep === 4) {

      props.income({
        divorce_id: window.localStorage.getItem("divorce_id"),
        lastMonthSalary: document.getElementById("lastMonthSalary").value,
        averageMonthSalary: document.getElementById("averageMonthSalary").value,
        lastMonthOvertime: document.getElementById("lastMonthOvertime").value,
        averageOvertime: document.getElementById("averageOvertime").value,
        lastMonthCommission: document.getElementById("lastMonthCommission").value,
        averageCommission: document.getElementById("averageCommission").value,

        currentlyReceiving: document.getElementById("currentlyReceiving").checked ? 1 : 0,
        publicAssistanceLastMonth: document.getElementById("publicAssistanceLastMonth").value,
        averagePublicAssistance: document.getElementById("averagePublicAssistance").value,


        spousalSupport: spousalCB,
        spousalSupportLastMonth: document.getElementById("spousalSupportLastMonth").value,
        averageSpousalSupport: document.getElementById("averageSpousalSupport").value,

        partnerSupport: partnerCB,
        lastMonthPartnerSupport: document.getElementById("lastMonthPartnerSupport").value,
        averagePartnerSupport: document.getElementById("averagePartnerSupport").value,

        lastMonthPension: document.getElementById("lastMonthPension").value,
        averagePension: document.getElementById("averagePension").value,
        lastMonthSecurityRetirement: document.getElementById("lastMonthSecurityRetirement").value,
        averageSecurityRetirement: document.getElementById("averageSecurityRetirement").value,

        disability: disabilityCB,
        lastMonthDisability: document.getElementById("lastMonthDisability").value,
        averageDisability: document.getElementById("averageDisability").value,

        lastMonthUnemployment: document.getElementById("lastMonthUnemployment").value,
        averageUnemployment: document.getElementById("averageUnemployment").value,
        lastMonthWorkersCompensation: document.getElementById("lastMonthWorkersCompensation").value,
        averageWorkersCompensation: document.getElementById("averageWorkersCompensation").value,
        militaryAllowances: document.getElementById("militaryAllowances").value,
        lastMonthMilitaryAllowances: document.getElementById("lastMonthMilitaryAllowances").value,
        averageMilitaryAllowances: document.getElementById("averageMilitaryAllowances").value,
      });
    } else if (activeStep === 5) {
      props.investIncome({
        divorce_id: window.localStorage.getItem("divorce_id"),
        lastMonthDividends: document.getElementById("lastMonthDividends").value,
        averageDividends: document.getElementById("averageDividends").value,
        lastMonthRentalProperty: document.getElementById("lastMonthRentalProperty").value,
        averageRentalProperty: document.getElementById("averageRentalProperty").value,
        trustLastMonth: document.getElementById("lastMonthInvestIncomeTrust").value,
        trustAverageMonthly: document.getElementById("averageInvestIncomeTrust").value,
        other: document.getElementById("otherIncome").value,
        otherLastMonth: document.getElementById("lastMonthOtherIncome").value,
        otherIncomeAverageMonthly: document.getElementById("averageOtherIncome").value,
      });
    } else if (activeStep === 6) {
      props.additionalIncome({
        divorce_id: window.localStorage.getItem("divorce_id"),
        oneTimeMoney: document.getElementById("oneTimeMoney").value,
      });
    } else if (activeStep === 7) {
      props.selfEmployeedIncome({
        divorce_id: window.localStorage.getItem("divorce_id"),
        selfEmployment: document.getElementById("selfEmployment").value,
        selfEmploymentOther: document.getElementById("selfEmploymentOther").value,
        bussinessYears: document.getElementById("bussinessYears").value,
        nameOfBusiness: document.getElementById("nameOfBusiness").value,
        typeOfBusiness: document.getElementById("typeOfBusiness").value,
      });
    } else if (activeStep === 8) {
      props.changeInIncome({
        divorce_id: window.localStorage.getItem("divorce_id"),
        changeInIncome: document.getElementById("changeInIncome").value,
      });
    } else if (activeStep === 9) {
      props.deductions({
        divorce_id: window.localStorage.getItem("divorce_id"),
        lastMonthRequiredUnionDues: document.getElementById("lastMonthRequiredUnionDues").value,
        lastMonthRequiredRetirementPayments: document.getElementById("lastMonthRequiredRetirementPayments").value,
        lastMonthHealthInsurance: document.getElementById("lastMonthHealthInsurance").value,
        lastMonthChildSupport: document.getElementById("lastMonthChildSupport").value,
        taxDeductible: document.getElementById("taxDeductible").checked ? 1 : 0,
        spousalSupportAnotherMarriage: document.getElementById("spousalSupportAnotherMarriage").value,
        partnerSupportAnotherMarriage: document.getElementById("partnerSupportAnotherMarriage").value,
        lastMonthJobRelated: document.getElementById("lastMonthJobRelated").value,
      });
    } else if (activeStep === 10) {
      props.asset({
        divorce_id: window.localStorage.getItem("divorce_id"),
        cashCheckcashCheck: document.getElementById("cashCheckcashCheck").value,
        lastMonthStockslastMonthStocks: document.getElementById("lastMonthStockslastMonthStocks").value,
        assetsOtherassetsOther: document.getElementById("assetsOtherassetsOther").value,
        lastMonthAssetsOtherlastMonthAssetsOther: document.getElementById("lastMonthAssetsOtherlastMonthAssetsOther").value,
      });
    }
    else if (activeStep === 11) {
      props.peopleLiveCall({
        divorce_id: window.localStorage.getItem("divorce_id"),
        data: inputFields.map(v => ({ ...v, 
          live_with_me_id: v.live_with_me_id, 
          divorce_id: window.localStorage.getItem("divorce_id") }))
      });
    }
    else if (activeStep === 12) {
      props.averageMonthallyExpenset({
        divorce_id: window.localStorage.getItem("divorce_id"),
        averageMonthlyExpenseBox: monthallyCB,
        home: document.getElementById("home").value,
        rentalCost: document.getElementById("rentalCosts").value,
        averagePrincipal: document.getElementById("averagePrincipal").value,
        averageInterest: document.getElementById("averageInterest").value,
        lastMonthRealProperty: document.getElementById("lastMonthRealProperty").value,
        lastMonthHomeOwner: document.getElementById("lastMonthHomeOwner").value,
        lastMonthMaintenance: document.getElementById("lastMonthMaintenance").value,
        lastMonthHealthCare: document.getElementById("lastMonthHealthCare").value,
        lastMonthChildCare: document.getElementById("lastMonthChildCare").value,
        lastMonthGroceriesSupplies: document.getElementById("lastMonthGroceriesSupplies").value,
        lastMonthEatingOut: document.getElementById("lastMonthEatingOut").value,
        lastMonthUtilities: document.getElementById("lastMonthUtilities").value,
        lastMonthTelephone: document.getElementById("lastMonthTelephone").value,
        laundryLaundry: document.getElementById("laundryLaundry").value,
        lastMonthClothes: document.getElementById("lastMonthClothes").value,
        lastMonthEducation: document.getElementById("lastMonthEducation").value,
        lastMonthEntertainment: document.getElementById("lastMonthEntertainment").value,
        lastMonthTransportation: document.getElementById("lastMonthTransportation").value,
        lastMonthInsurance: document.getElementById("lastMonthInsurance").value,
        lastMonthSavings: document.getElementById("lastMonthSavings").value,
        charitableCharitable: document.getElementById("charitableCharitable").value,
        monthlyPaymentsMonthlyPayments: document.getElementById("monthlyPaymentsMonthlyPayments").value,
        monthallyExpenseOther: document.getElementById("monthallyExpenseOther").value,
        lastMonthMonthallyExpenseOther: document.getElementById("lastMonthMonthallyExpenseOther").value,
        lastMonthTotalExpenses: document.getElementById("lastMonthTotalExpenses").value,
        lastMonthAmountOfExpenses: document.getElementById("lastMonthAmountOfExpenses").value,
      });
    }
    else if (activeStep === 13) {
      props.installmentPaymentsCall({
        divorce_id: window.localStorage.getItem("divorce_id"),
        data: inputFieldsInstallment.map(v => ({ ...v, 
          fl_150_installments_id: v.fl_150_installments_id, 
          divorce_id: window.localStorage.getItem("divorce_id") }))
      });
    }
    else if (activeStep === 14) {
      props.attorneyFee({
        divorce_id: window.localStorage.getItem("divorce_id"),
        attorneyFee: document.getElementById("attorneyFee").value,
        dateAttorneyFeePaid: document.getElementById("dateAttorneyFeePaid").value,
        sourceOfMoney: document.getElementById("sourceOfMoney").value,
        stillOwe: document.getElementById("stillOwe").value,
        hourlyRate: document.getElementById("hourlyRate").value,
      });
    }
    else if (activeStep === 15) {
      props.numberOfChildren({
        divorce_id: window.localStorage.getItem("divorce_id"),
        numberOfChildren: document.getElementById("numberOfChildren").value,
        timeWithYou: document.getElementById("timeWithYou").value,
        timeWithOther: document.getElementById("timeWithOther").value,
      });
    } else if (activeStep === 16) {
      props.childHealthExpenses({
        divorce_id: window.localStorage.getItem("divorce_id"),
        healthInsurance: document.getElementById("healthInsurance").value,
        insuranceCompany: document.getElementById("insuranceCompany").value,
        insuranceCompanyAddress: document.getElementById("insuranceCompanyAddress").value,
        monthlyCost: document.getElementById("monthlyCost").value,
      });
    } else if (activeStep === 17) {
      props.childAdditionalExpenses({
        divorce_id: window.localStorage.getItem("divorce_id"),
        lastChildCareExpense: document.getElementById("lastChildCareExpense").value,
        lastChildrenHealthAmount: document.getElementById("lastChildrenHealthAmount").value,
        lastChildTravelExpenses: document.getElementById("lastChildTravelExpenses").value,
        educationalNeeds: document.getElementById("educationalNeeds").value,
        MonthallyeducationalNeeds: document.getElementById("MonthallyeducationalNeeds").value,
      });
    } else if (activeStep === 18) {
      props.specialHardship({
        divorce_id: window.localStorage.getItem("divorce_id"),
        childrenSpecify: document.getElementById("nameAndAges").value,
        lastExtraHealthExpenses: document.getElementById("lastExtraHealthExpenses").value,
        monthsForExtraHealthExpenses: document.getElementById("monthsForExtraHealthExpenses").value,
        PerMonthMajorLosses: document.getElementById("PerMonthMajorLosses").value,
        monthForMajorLosses: document.getElementById("monthForMajorLosses").value,
        PerMinorChildExpenses: document.getElementById("PerMinorChildExpenses").value,
        expenses: document.getElementById("expenses").value,
        monthallyChildSupport: document.getElementById("monthallyChildSupport").value,
        extremeFinancialHardship: document.getElementById("extremeFinancialHardship").value,
      });
    } else if (activeStep === 19) {
      props.otherInformation({
        divorce_id: window.localStorage.getItem("divorce_id"),
        otherCourtInfo: document.getElementById("otherCourtInfo").value,
      });
    } else if (activeStep === 20) {
    } else if (activeStep === 21) {
    } else if (activeStep === 22) {
    } else {
    }
  };


  const handleNext = () => {
    handlePostFunc();
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    activeStep === 12 && setInputField(isEmpty(props.peopleLive) ? [{ name: "", age: "", person_related: "", person_monthly_income: "", household_expenses: "" }] : props.peopleLive);

    activeStep === 14 && setInputFieldInstallment(isEmpty(props.installmentPayments) ? [{ toPaymentInstallment: "", forPaymentInstallment: "", amountInstallment: "", balanceInstallment: "", dateLastInstallment: "" }] : (props.installmentPayments));

    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [inputFields, setInputField] = useState(isEmpty(props.peopleLive) ? [{ name: "", age: "", person_related: "", person_monthly_income: "", household_expenses: "-1" }] : props.peopleLive);
  const [inputFieldsInstallment, setInputFieldInstallment] = useState(isEmpty(props.installmentPayments) ? [{ toPaymentInstallment: "", forPaymentInstallment: "", amountInstallment: "", balanceInstallment: "", dateLastInstallment: "" }] : (props.installmentPayments));
  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.id] = event.target.value;
    setInputField(values);

  }


  const handleAddFields = () => {
    setInputField([...inputFields, { name: "", age: "", person_related: "", person_monthly_income: "", household_expenses: "-1" }])
  }

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    if (index > 0) {
      values.splice(index, 1);
      setInputField(values);
    }
    else {
      values.splice(index, 1);
      setInputField([{ name: "", age: "", person_related: "", person_monthly_income: "", household_expenses: "" }]);
    }
  }


  const handleChangeInputInstallment = (index, event) => {
    const values = [...inputFieldsInstallment];
    values[index][event.target.id] = event.target.value;
    setInputFieldInstallment(values);

  }

  const handleAddFieldsInstallment = () => {
    setInputFieldInstallment([...inputFieldsInstallment, { toPaymentInstallment: "", forPaymentInstallment: "", amountInstallment: "", balanceInstallment: "", dateLastInstallment: "" }])
  }

  const handleRemoveFieldsInstallment = (index) => {
    const values = [...inputFieldsInstallment];
    if (index > 0)
      values.splice(index, 1);
    setInputFieldInstallment(values);
  }

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        borderTop: "2px solid",
        color: "black",
      }}
    />
  );


  const deleteCall = (index) => {
    props.deletePeopleLiveCall({
      live_with_me_id: props.peopleLive != "" && get(props.peopleLive, `${index}.live_with_me_id`, ""),
      divorce_id: window.localStorage.getItem("divorce_id"),
    })
  }

  const deleteInstallCall = (index) => {
    props.deleteInstallmentCall({
      fl_150_installments_id: props.installmentPayments != "" && get(props.installmentPayments, `${index}.fl_150_installments_id`, ""),
      divorce_id: window.localStorage.getItem("divorce_id"),
    })
  }



  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            {/* Q1 */}
            <FormGroup>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="employer">Employer</Label>
                    <Input
                      defaultValue={props.employement.employer}
                      type="text"
                      name="employerFirstName"
                      id="employerFirstName"
                      placeholder="First Name"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="address">Employer's Address</Label>
                    <Input
                      defaultValue={props.employement.address}
                      type="text"
                      name="employerAddress"
                      id="employerAddress"
                      placeholder="Address"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="phoneNumber">Employer's Phone Number</Label>
                    <PhoneInput
                      value={props.employement.phoneNumber || value}
                      onChange={(e) => setValue(JSON.parse(value))}
                      id="employerPhoneNumber"
                      name="employerPhoneNumber"
                      placeholder="Format (XXX) XXX-XXXX"
                      required
                    />

                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="occupation">Occupation</Label>
                    <Input
                      defaultValue={props.employement.occupation}
                      type="text"
                      name="occupation"
                      id="occupation"
                      placeholder="Occupation"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="dateJobStarted">Date Job Started</Label>
                    <Input
                      defaultValue={moment(props.employement.jobStartedDate == "1947-01-01" ? "" : props.employement.jobStartedDate).format('YYYY-MM-DD')}
                      type="date"
                      name="dateJobStarted"
                      id="dateJobStarted"
                      placeholder="Date job started"
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="dateJobEnded">
                      Date Job Ended(if unemployed)
                    </Label>
                    <Input
                      defaultValue={moment(props.employement.jobEndedDate == "1947-01-01" ? "" : props.employement.jobEndedDate).format('YYYY-MM-DD')}
                      type="date"
                      name="dateJobEnded"
                      id="dateJobEnded"
                      placeholder="Date job started"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="workPerHour">Working Hours In Week</Label>
                    <Input
                      defaultValue={props.employement.workingHoursWeekly}
                      type="text"
                      name="workPerHour"
                      id="workPerHour"
                    />
                  </FormGroup>
                </Col>

                <Col md={8}>
                  <Row>
                    <Col md={4}>
                      <Label for="getPaid">I get Paid Gross</Label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.employement.paidGross}
                          type="number" id="getPaid" />
                      </InputGroup>
                    </Col>

                    <Col md={8}>
                      <Label for="">Please Select</Label>
                      <div>
                        <CustomInput
                          type="radio"
                          id="1"
                          name="salaryType"
                          label="Per Month"
                          defaultChecked={props.employement.salaryType == 1}
                          inline
                          onChange={selectSalaryType}
                        />
                        <CustomInput
                          type="radio"
                          id="2"
                          defaultChecked={props.employement.salaryType == 2}
                          name="salaryType"
                          label="Per Week"

                          inline
                          onChange={selectSalaryType}
                        />
                        <CustomInput
                          type="radio"
                          id="3"
                          defaultChecked={props.employement.salaryType == 3}
                          name="salaryType"
                          label="Per Hour"

                          inline
                          onChange={selectSalaryType}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 1:
        return (
          <div>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="age">My age is </Label>
                  <Input
                    defaultValue={props.ageAndEducation.age}
                    type="text"
                    name="age"
                    id="age"
                    placeholder="Age"
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <Row>
                  <Col md={12}>
                    <Label for="highSchoolDegree">
                      I have completed high school or the equivalent
                    </Label>
                    <div>
                      <FormGroup inline>
                        <Input
                          defaultValue={props.ageAndEducation.isHighSchoolDegreeCompleted}
                          type="select"
                          name="highSchoolDegree"
                          id="highSchoolDegree"
                        >
                          <option selected value="-1">

                            -- select an option --
                          </option>
                          <option value="1">Yes</option>
                          <option value="0">No</option>
                        </Input>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* 2nd Part of Q2 */}
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="noOfCollegeYears">
                    Number of years of college completed
                  </Label>
                  <Input
                    defaultValue={props.ageAndEducation.NumberOfYearsCollege}
                    type="text" name="noOfCollegeYears" id="noOfCollegeYears" />
                </FormGroup>

                <FormGroup>
                  <Label for="noOfGraduateYears">
                    Number of years of graduate school completed
                  </Label>
                  <Input
                    defaultValue={props.ageAndEducation.NumberOfYearsGraduates}
                    type="text" name="noOfGraduateYears" id="noOfGraduateYears" />
                </FormGroup>
              </Col>

              <Col md={6}>

                <FormGroup>
                  <Label for="collegeDegreeName">
                    Degree Obtained?
                  </Label>
                  <Input
                    defaultValue={props.ageAndEducation.specifyCollegeDegree}
                    id="collegeDegreeName" placeholder="Specify"></Input>
                </FormGroup>

                <FormGroup>
                  <Label for="garduateDegreeName">
                    Degree Obtained?
                  </Label>
                  <Input
                    defaultValue={props.ageAndEducation.specifyGraduateDegree}
                    id="garduateDegreeName" placeholder="Specify"></Input>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>I Have</Label>
              <Row>
                <Col md={6}>
                  <Label for="professionalOccupational">
                    Professional/Occupational License
                  </Label>
                  <Input
                    defaultValue={props.ageAndEducation.professionalOccupational}
                    id="professionalOccupationalSpecific" type="text" placeholder="Specify"></Input>
                </Col>
                <Col md={6}>
                  <Label for="vocationalTrainingSpecific">
                    Vocational Training
                  </Label>
                  <Input
                    defaultValue={props.ageAndEducation.vocationalTraining}
                    id="vocationalTrainingSpecific" type="text" placeholder="Specify"></Input>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 2:
        return (
          <div>
            <FormGroup>
              <Label for="taxYear">I Last Filed Taxes For Tax Year</Label>
              <Input
                defaultValue={props.taxInData.lastTaxYear}
                id="taxYear"
                type="text"
                placeholder="Please Specify"
              ></Input>
            </FormGroup>
            {/* B part */}
            <FormGroup>
              <Label for="taxFilingStatus">My Tax Filing Status is</Label>
              <Input
                onChange={(e) => setSpouseName(JSON.parse(e.target.value))}
                defaultValue={props.taxInData.taxFilingStatus}
                type="select" name="taxFilingStatus" id="taxFilingStatus">

                <option selected value="-1">
                  select an option
                </option>

                <option value="0">single</option>
                <option value="1">head of household</option>
                <option value="2">married, filing separately</option>
                <option value="3">married, filing jointly with </option>

              </Input>
            </FormGroup>
            <Collapse isOpen={spouseName == 3}>
              <FormGroup>
                <Label for="fileTaxState">Your Spouse Name</Label>
                <Input type="text" id="spouseName"
                  defaultValue={props.taxInData.spouseName} />
              </FormGroup>
            </Collapse>
            
            <FormGroup>
              <Label for="californiaState">Do you file a California tax return?</Label>
              <Input
                defaultValue={props.taxInData.californiaState}
                type="select"
                name="californiaState"
                id="californiaState"
                onChange={(e) => setState(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  select an option
                </option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Input>
            </FormGroup>

            <Collapse isOpen={state == "1"}>

              <FormGroup>
                <Label for="fileTaxState">Do you file a tax return in another state?</Label>
                <Input
                  defaultValue={props.taxInData.taxReturnState}
                  type="select"
                  name="fileTaxState"
                  id="fileTaxState"
                  onChange={(e) => setfileTax(JSON.parse(e.target.value))}
                >
                  <option selected value="-1">
                    select an option
                  </option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </Input>
              </FormGroup>
              <Collapse isOpen={fileTax == "1"}>
                <Input
                  defaultValue={props.taxInData.outSideCalifornia}
                  type="text" id="outSideCalifornia" placeholder="Specify" />
              </Collapse>
            </Collapse>
            {/* D Part */}
            <FormGroup>
              <Label for="exemptionsOnTaxt">
                I claim the following number of exemptions (including myself) on
                my taxes
              </Label>
              <InputGroup>
                <Input
                  defaultValue={props.taxInData.exemptionsOnTax}
                  type="text" name="exemptionsOnTaxt" id="exemptionsOnTaxt" placeholder="Specify"></Input>
              </InputGroup>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 3:
        return (
          <div>

            <FormGroup>
              <Label for="otherPartyIncome">
                I estimate the gross monthly income (before taxes) of the other
                party in this case at
              </Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input
                  defaultValue={props.otherPartyData.grossMonthallyIncome}
                  type="number"
                  id="otherPartyIncome"
                  name="otherPartyIncome"
                  placeholder="Specify"
                ></Input>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label for="estimateBasedOn">This estimate is based on </Label>
              <Input
                defaultValue={props.otherPartyData.estimateBasedOn}
                type="text" name="estimateBasedOn" id="estimateBasedOn" placeholder="Explain"></Input>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 4:
        return (
          <div>
            <FormGroup>
              {/* <Alert style={{
                backgroundColor: "#f0fbfb",
                color: "black"
              }} icon={false} severity="warning">
                <b>Warning:</b>
                Please answer every question. If it does not apply to you, put in $0.0.
                This is required by court rules and your form will not print otherwise.</Alert> */}
              <Row style={{ marginTop: "10px" }}>
                <Col md={6}>
                  <Label for="salary" md={12}>
                    A. Salary or wages (gross, before taxes).
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeSalaryWages.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthSalary" name="lastMonth"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeSalaryWages.averageMonthally}
                          type="number"
                          id="averageMonthSalary"
                          placeholder="Average Monthly"
                          name="averageMonthly"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* B */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="overtime" md={12}>
                    B. Overtime (gross, before taxes)
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeOverTime.lastMonth}
                          type="number" id="lastMonthOvertime" placeholder="Last Month" name="lastMonthOvertime"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeOverTime.averageMonthally}
                          type="number"
                          id="averageOvertime"
                          placeholder="Average Monthly"
                          name="averageMonthly"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* C */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="commissions" md={12}>
                    C. Commissions or bonuses
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeCommissions.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthCommission" name="lastMonthCommission"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeCommissions.averageMonthally}
                          type="number"
                          id="averageCommission"
                          placeholder="Average Monthly"
                          name="averageMonthly"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* D */}

            <FormGroup>
              <Row>
                <Col md={3}>
                  <Label for="Public assistance" md={12}>
                    D. Public assistance (TANF, SSI, GA/GR)
                  </Label>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <CustomInput
                      type="checkbox"
                      id="currentlyReceiving"
                      label="currently receiving"
                      defaultChecked={props.incomePublicAssistance.currentlyReceivingCheck == 1}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomePublicAssistance.lastMonth}
                          type="number" placeholder="Last Month" id="publicAssistanceLastMonth" name="lastMonth"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomePublicAssistance.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageMonthly"
                          id="averagePublicAssistance"
                        ></Input>
                      </InputGroup>

                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* E */}

            <FormGroup>
              <Row>
                <Col md={3}>
                  <Label for="spousalSupport" md={12}>
                    E. Spousal support
                  </Label>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <CustomInput
                      value="1"
                      type="checkbox"
                      id="fromThisMarriage"
                      name="spousalSupport"
                      label="from this marriage"
                      onChange={(e) => boxesSpousal(e.target.value)}
                      defaultChecked={!isEmpty(props.incomeSpousalSuport.spousalSuportCheck) && size(props.incomeSpousalSuport.spousalSuportCheck.find(x => x === '1'))}
                    />
                    <CustomInput
                      type="checkbox"
                      id="fromDifferentMarriage"
                      name="spousalSupport"
                      label="from different marriage"
                      value="2"
                      onChange={(e) => boxesSpousal(e.target.value)}
                      defaultChecked={!isEmpty(props.incomeSpousalSuport.spousalSuportCheck) && size(props.incomeSpousalSuport.spousalSuportCheck.find(x => x === '2'))}
                    />
                    <CustomInput
                      type="checkbox"
                      id="federallyTaxable"
                      name="spousalSupport"
                      label="federally taxable"
                      value="3"
                      onChange={(e) => boxesSpousal(e.target.value)}
                      defaultChecked={!isEmpty(props.incomeSpousalSuport.spousalSuportCheck) && size(props.incomeSpousalSuport.spousalSuportCheck.find(x => x === '3'))}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeSpousalSuport.lastMonth}
                          type="number" id="spousalSupportLastMonth" placeholder="Last Month" name="spousalSupportLastMonth"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeSpousalSuport.averageMonthally}
                          type="number"
                          id="averageSpousalSupport"
                          placeholder="Average Monthly"
                          name="averageSpousalSupport"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* F */}

            <FormGroup>
              <Row>
                <Col md={3}>
                  <Label for="partnerSupport" md={12}>
                    F. Partner support
                  </Label>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <CustomInput
                      value="1"
                      type="checkbox"
                      id="fromDomesticPartnership"
                      name="partnerSupport"
                      label="from this domestic partnership"
                      onChange={(e) => boxesPartner(e.target.value)}
                      defaultChecked={!isEmpty(props.incomePartnerSupport.partnerSupportCheck) && size(props.incomePartnerSupport.partnerSupportCheck.find(x => x === '1'))}
                    />
                    <CustomInput
                      value="2"
                      type="checkbox"
                      id="fromDifferentPartnership"
                      name="partnerSupport"
                      label="from different domestic partnership"
                      onChange={(e) => boxesPartner(e.target.value)}
                      defaultChecked={!isEmpty(props.incomePartnerSupport.partnerSupportCheck) && size(props.incomePartnerSupport.partnerSupportCheck.find(x => x === '2'))}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomePartnerSupport.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthPartnerSupport" name="lastMonthPartnerSupport"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomePartnerSupport.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averagePartnerSupport"
                          id="averagePartnerSupport"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* G */}
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="pension" md={12}>
                    G. Pension/retirement fund payments
                  </Label>
                </Col>

                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomePensionRetirementFund.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthPension" name="lastMonthPension"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomePensionRetirementFund.averageMonthally}
                          type="numbers"
                          id="averagePension"
                          placeholder="Average Monthly"
                          name="averagePension"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* H */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="securityRetirement" md={12}>
                    H. Social Security retirement (not SSI)
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeSocialSecurity.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthSecurityRetirement" name="lastMonthSecurityRetirement"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeSocialSecurity.averageMonthally}
                          type="number"
                          id="averageSecurityRetirement"
                          placeholder="Average Monthly"
                          name="averageMonthly"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* I */}

            <FormGroup>
              <Row>
                <Col md={3}>
                  <Label for="disability" md={12}>
                    I. Disability
                  </Label>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <CustomInput
                      type="checkbox"
                      value="1"
                      id="1"
                      name="disability"
                      label="Social Security(not SSI)"
                      onChange={(e) => boxesDisability(e.target.value)}
                      defaultChecked={!isEmpty(props.incomeDisability.disabilityCheck) && size(props.incomeDisability.disabilityCheck.find(x => x === '1'))}
                    />
                    <CustomInput
                      type="checkbox"
                      value="2"
                      id="2"
                      name="disability"
                      label="State disability(SDI)"
                      onChange={(e) => boxesDisability(e.target.value)}
                      defaultChecked={!isEmpty(props.incomeDisability.disabilityCheck) && size(props.incomeDisability.disabilityCheck.find(x => x === '2'))}
                    />
                    <CustomInput
                      value="3"
                      type="checkbox"
                      id="3"
                      name="disability"
                      label="Private insurance"
                      onChange={(e) => boxesDisability(e.target.value)}
                      defaultChecked={!isEmpty(props.incomeDisability.disabilityCheck) && size(props.incomeDisability.disabilityCheck.find(x => x === '3'))}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeDisability.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthDisability" name="lastMonthDisability"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeDisability.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageDisability"
                          id="averageDisability"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            {/* J */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="unemploymentCompensation" md={12}>
                    J. Unemployment compensation
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeUnemploymentCompensation.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthUnemployment" name="lastMonthUnemployment"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeUnemploymentCompensation.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageUnemployment"
                          id="averageUnemployment"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* k */}
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="workersCompensation" md={12}>
                    K. Workers' compensation
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeWorkerCompensation.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthWorkersCompensation" name="lastMonthWorkersCompensation"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeWorkerCompensation.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageWorkersCompensation"
                          id="averageWorkersCompensation"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* I */}

            <FormGroup>
              <Row>
                <Col md={3}>
                  <Label for="militaryAllowances" md={12}>
                    L. Other(military allowances, royalty payments)
                  </Label>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Input
                      defaultValue={props.incomeOthers.specific}
                      id="militaryAllowances" type="text" placeholder="Specify"></Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeOthers.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthMilitaryAllowances" name="lastMonthMilitaryAllowances"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.incomeOthers.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageMilitaryAllowances"
                          id="averageMilitaryAllowances"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 5:
        return (
          <div>
            {" "}
            <FormGroup>
              {/* <Alert style={{
                backgroundColor: "#f0fbfb",
                color: "black"
              }} icon={false} severity="warning">
                <b>Warning:</b>
                Please answer every question. If it does not apply to you, put in $0.0.
                This is required by court rules and your form will not print otherwise.</Alert> */}
              <Row style={{ marginTop: "10px" }}>
                <Col md={6}>
                  <Label for="dividends" md={12}>
                    A. Dividends/interest
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.dividendsInterest.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthDividends" name="lastMonthdividends"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.dividendsInterest.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageDividends"
                          id="averageDividends"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            {/* B */}
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="rentalProperty" md={12}>
                    B. Rental property income
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.rentalPropertyIncome.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthRentalProperty" name="lastMonthRentalProperty"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.rentalPropertyIncome.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageRentalProperty"
                          id="averageRentalProperty"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            {/* C */}
            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="trustIncome" md={12}>
                    C. Trust Income
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.workerCompensation.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthInvestIncomeTrust" name="lastMonthInvestIncomeTrust"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.workerCompensation.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageInvestIncomeTrust"
                          id="averageInvestIncomeTrust"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            {/* D */}
            <FormGroup>
              <Row>
                <Col md={3}>
                  <Label for="other" md={12}>
                    D. Other
                  </Label>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Input
                      defaultValue={props.trustIncome.specific}
                      type="text" id="otherIncome" placeholder="Specify"></Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.trustIncome.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthOtherIncome" name="lastMonthTrustIncome"></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.trustIncome.averageMonthally}
                          type="number"
                          placeholder="Average Monthly"
                          name="averageOtherIncome"
                          id="averageOtherIncome"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 6:
        return (
          <div>
            <Row>
              <Col md={12}>
                <InputGroup>

                  <Input
                    defaultValue={props.oneTimeMoney.specific}
                    type="text"
                    placeholder="Amount and Source"
                    id="oneTimeMoney"
                    name="oneTimeMoney"
                  ></Input>
                </InputGroup>
              </Col>
            </Row>
          </div>
        );
      case 7:
        return (
          <div>
            <FormGroup>
              <Label for="selfEmployment">I am the</Label>
              <Input
                defaultValue={props.selfEmploymentType}
                type="select"
                name="selfEmployment"
                id="selfEmployment"
                onChange={(e) => setSelfEmployment(JSON.parse(e.target.value))}
              >
                <option selected value="-1">

                  -- select an option --
                </option>
                <option value="0">owner/sole proprietor</option>
                <option value="1">business partner</option>
                <option value="2">other </option>
              </Input>
            </FormGroup>

            <Collapse isOpen={selfEmployment == "2"}>
              <Input
                defaultValue={props.selfEmploymentSpecify}
                type="text" id="selfEmploymentOther" placeholder="Specify" />
            </Collapse>

            {/* 3rd Part */}

            <Row form>
              <Col md={6}>
                <FormGroup>
                  <Label for="bussinessYears">
                    Number of years in this business
                  </Label>
                  <Input
                    defaultValue={props.selfEmploymentBusinessYears}
                    type="text"
                    name="bussinessYears"
                    id="bussinessYears"
                    placeholder="Specify"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="nameOfBusiness">Name of business </Label>
                  <Input
                    defaultValue={props.selfEmploymentBusinessName}
                    type="text"
                    name="nameOfBusiness"
                    id="nameOfBusiness"
                    placeholder="Specify"
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="typeOfBusiness">Type of business</Label>
              <Input
                defaultValue={props.selfEmploymentBusinessType}
                type="text"
                name="typeOfBusiness"
                id="typeOfBusiness"
                placeholder="Specify"
              />
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 8:
        return (
          <div>
            <Label>If you have had a significant change in your financial situation please specify:</Label>
            <InputGroup>

              <Input
                defaultValue={props.changeInMoney}
                type="text"
                name="changeInIncome"
                id="changeInIncome"
              />
            </InputGroup>
          </div>
        );
      case 9:
        return (
          <div>
            <FormGroup>
              {/* <Alert style={{
                backgroundColor: "#f0fbfb",
                color: "black"
              }} icon={false} severity="warning">
                <b>Warning:</b>
                Please answer every question. If it does not apply to you, put in $0.0.
                This is required by court rules and your form will not print otherwise.</Alert> */}
              <Row style={{ marginTop: "10px" }}>
                <Col md={9}>
                  <Label for="requiredUnionDues" md={12}>
                    A.Required union dues
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.requiredUnionDues.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthRequiredUnionDues"
                          id="lastMonthRequiredUnionDues"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* B */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="requiredRetirementPayments" md={12}>
                    B.Required retirement payments(not Social Security, FICA,
                    401(k), or IRA)
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.requiredRetirementPay.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthRequiredRetirementPayments"
                          id="lastMonthRequiredRetirementPayments"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* C */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="healthInsurance" md={12}>
                    C.Medical, hospital, dental, and other health insurance
                    premiums (total monthly amount)
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.healthExpenses.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthHealthInsurance"
                          id="lastMonthHealthInsurance"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* D */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="childSupport" md={12}>
                    D.Child support that I pay for children from other
                    relationships
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.childSupport.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthChildSupport"
                          id="lastMonthChildSupport"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* E */}

            <FormGroup>
              <Row>
                <Col md={7}>
                  <Label for="spousalSupportAnotherMarriage" md={12}>
                    E.Spousal support that I pay by court order from a different
                    marriage
                  </Label>
                </Col>

                <Col md={2}>
                  <FormGroup>
                    <CustomInput
                      type="checkbox"
                      id="taxDeductible"
                      label="federally tax deductible"
                      defaultChecked={props.spousalSupport.federallytax == 1}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.spousalSupport.lastMonth}
                          type="number" placeholder="Last Month" id="spousalSupportAnotherMarriage" name="spousalSupportAnotherMarriage"></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* F */}
            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="partnerSupportAnotherMarriage" md={12}>
                    F.Partner support that I pay by court order from a different
                    domestic partnership
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.partnerSupport.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="partnerSupportAnotherMarriage"
                          id="partnerSupportAnotherMarriage"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* G */}
            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="jobRelated" md={12}>
                    G.Necessary job-related expenses not reimbursed by my
                    employer{" "}
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.jobExpenses.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthJobRelated"
                          id="lastMonthJobRelated"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 10:
        return (
          <div>
            {" "}
            <FormGroup>
              {/* <Alert style={{
                backgroundColor: "#f0fbfb",
                color: "black"
              }} icon={false} severity="warning">
                <b>Warning:</b>
                Please answer every question. If it does not apply to you, put in $0.0.
                This is required by court rules and your form will not print otherwise.</Alert> */}
              <Row style={{ marginTop: "10px" }}>
                <Col md={9}>
                  <Label for="cashCheck" md={12}>
                    A.Cash and checking accounts, savings, credit union, money
                    market, and other deposit accounts.{" "}
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.accounts.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonth"
                          id="cashCheckcashCheck"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            {/* B */}
            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="stocks" md={12}>
                    B.Stocks, bonds, and other assets I could easily sell{" "}
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.stockBonds.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthStocks"
                          id="lastMonthStockslastMonthStocks"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            {/* C */}
            <FormGroup>
              <Row>
                <Col md={7}>
                  <Label for="assetsOther" md={12}>
                    C.All other property
                  </Label>
                </Col>

                <Col md={2}>
                  <FormGroup>
                    <Input
                      defaultValue={props.otherPropert.type}
                      type="select" id="assetsOtherassetsOther" name="assetsOther">
                      <option selected value="-1">

                        -- select an option --
                      </option>
                      <option value="0">Real Property</option>
                      <option value="1">Personal Property</option>
                      <option value="2">Both</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.otherPropert.lastMonth}
                          type="number" placeholder="Last Month" id="lastMonthAssetsOtherlastMonthAssetsOther" name="lastMonthAssetsOther"></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 11:
        return (
          <div>
            {!isEmpty(inputFields) && inputFields.map((input, index) => (
              <div key={index}>

                <Row>
                  <Col xl={4} lg={4} md={12} sm={12}>
                    <br></br>
                    <Label>Name:</Label>
                    <Input style={{ marginLeft: "2px" }} type="text" id="name"
                      onBlur={(e) => { handleChangeInput(index, e) }}
                      defaultValue={input.name}
                    />
                  </Col>

                  <Col xl={2} lg={2} md={12} sm={12} xs={12}>
                    <br></br>
                    <Label>Age:</Label>

                    <Input type="number" id="age"
                      onChange={(e) => { handleChangeInput(index, e) }}
                      defaultValue={input.age}
                    />
                  </Col>

                  <Col xl={6} lg={6} md={12} sm={12}>
                    <br></br>
                    <Label>How the person is related to me (ex: son):</Label>
                    <Input type="text" id="person_related"
                      onBlur={(e) => { handleChangeInput(index, e) }}
                      defaultValue={input.person_related}
                    />
                  </Col>

                </Row>

                <Row>

                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <br></br>
                    <Label>That person's gross monthly income:</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>$</InputGroupText>
                      </InputGroupAddon>
                      <Input type="number" id="person_monthly_income"
                        onBlur={(e) => { handleChangeInput(index, e) }}
                        defaultValue={input.person_monthly_income}
                      />
                    </InputGroup>
                  </Col>

                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <br></br>
                    <Label>Pays some of the household expenses?</Label>

                    <Input type="select" id="household_expenses"
                      onChange={(e) => { handleChangeInput(index, e) }}
                      defaultValue={input.household_expenses}
                    >
                      <option selected value="-1"> -- select an option -- </option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </Input>
                  </Col>

                </Row>

                <Row>
                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <IconButton onClick={() => { handleRemoveFields(index); deleteCall(index) }} style={{ float: "right", color: "black", marginTop: "15px" }} >
                      <RemoveIcon />
                    </IconButton>

                    {size(inputFields) < 5 && <IconButton onClick={() => handleAddFields()} style={{
                      float: "right", color: "black", marginTop: "15px",
                      pointerEvents: size(inputFields) < 5 ? 'all' : 'none'
                    }}>
                      <AddIcon />
                    </IconButton>}
                  </Col>
                </Row>
                <ColoredLine />
              </div>
            ))}
          </div>

        );

      case 12:
        return (
          <div>
            <FormGroup>
              {/* <Alert style={{
                backgroundColor: "#f0fbfb",
                color: "black"
              }} icon={false} severity="warning">
                <b>Warning:</b>
                Please answer every question. If it does not apply to you, put in $0.0.
                This is required by court rules and your form will not print otherwise.</Alert> */}
              <Row style={{ marginLeft: "10px" }}>
                <Col lg={4}>
                  <Input type="checkbox" id="estimatedCb" value="1"
                    onChange={(e) => boxesMonthally(e.target.value)}
                    defaultChecked={!isEmpty(props.homeStatus.averageMonthlyExpenseBox) && size(props.homeStatus.averageMonthlyExpenseBox.find(x => x === '1'))}>
                  </Input>
                  <Label>Estimated expenses</Label>
                </Col>
                <Col lg={4}>
                  <Input type="checkbox" id="actualCb" value="2"
                    onChange={(e) => boxesMonthally(e.target.value)}
                    defaultChecked={!isEmpty(props.homeStatus.averageMonthlyExpenseBox) && size(props.homeStatus.averageMonthlyExpenseBox.find(x => x === '2'))}>
                  </Input>
                  <Label>Actual expenses</Label>
                </Col>
                <Col lg={4}>
                  <Input type="checkbox" id="proposedCb" value="3"
                    onChange={(e) => boxesMonthally(e.target.value)}
                    defaultChecked={!isEmpty(props.homeStatus.averageMonthlyExpenseBox) && size(props.homeStatus.averageMonthlyExpenseBox.find(x => x === '3'))}>
                  </Input>
                  <Label>Proposed needs</Label>
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Label for="home">A. Home</Label>
              <Input
                defaultValue={props.homeStatus.rent}
                type="select"
                name="home"
                id="home"
                onChange={(e) => setIsMortgage(JSON.parse(e.target.value))}
              >
                <option selected value="-1">

                  -- select an option --
                </option>
                <option value="0">Rent</option>
                <option value="1">Mortgage</option>
              </Input>
            </FormGroup>

            <Collapse isOpen={isMortgage == "0"}>
              <FormGroup>
                <Label for="rentalCosts">Rental Costs</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.homeStatus.rental.rentalCost}
                    type="number" name="rentalCosts" id="rentalCosts" />
                </InputGroup>
              </FormGroup>
            </Collapse>

            <Collapse isOpen={isMortgage == "1"}>
              <FormGroup>
                <Label for="averagePrincipal">Average principal</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.homeStatus.mortgage.averagePrincipal}
                    type="number" name="averagePrincipal" id="averagePrincipal" />
                </InputGroup>
                <Label for="averageInterest">Average interest</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.homeStatus.mortgage.averageIntrest}
                    type="number" name="averagePrincipal" id="averageInterest" />
                </InputGroup>
              </FormGroup>
            </Collapse>

            {/* A2 */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="realProperty" md={12}>
                    1.Real property taxes
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.realPropertyTax.lastMonth}
                          type="number"
                          placeholder="Last Month"

                          name="lastMonthRealProperty"
                          id="lastMonthRealProperty"


                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* A3 */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="homeOwner" md={12}>
                    2.Homeowner's or renter's insuranceif not included above)
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.homeOwnerInsurance.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthHomeOwner"
                          id="lastMonthHomeOwner"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* A4 */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="maintenance" md={12}>
                    3.Maintenance and repair
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.maintainance.lastMonth}
                          type="number"
                          placeholder="Last Month"
                          name="lastMonthMaintenance"
                          id="lastMonthMaintenance"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* B&C */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="lastMonthHealthCare" md={12}>
                        B.Health-care costs not paid by insurance
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.healthCareCost.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthHealthCare"
                              id="lastMonthHealthCare"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="childCare" md={12}>
                        C.Child care
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.childCareCost.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthChildCare"
                              id="lastMonthChildCare"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* D & E */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="groceriesSupplies" md={12}>
                        D.Groceries and household supplies
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.householdSupplies.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthGroceriesSupplies"
                              id="lastMonthGroceriesSupplies"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="eatingOut" md={12}>
                        E.Eating out
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.eatingOut.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthEatingOut"
                              id="lastMonthEatingOut"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* F & G */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="utilities" md={12}>
                        F.Utilities (gas, electric, water, trash)
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.utilities.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthUtilities"
                              id="lastMonthUtilities"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="telephone" md={12}>
                        G.Telephone, cell phone, and e-mail
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.telephone.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthTelephone"
                              id="lastMonthTelephone"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* H & I */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="laundry" md={12}>
                        H.Laundry and cleaning
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.laundaryCleaning.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthLaundry"
                              id="laundryLaundry"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="clothes" md={12}>
                        I.Clothes
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.clothes.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthClothes"
                              id="lastMonthClothes"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* J & K */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="education" md={12}>
                        J.Education
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.education.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthEducation"
                              id="lastMonthEducation"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="entertainment" md={12}>
                        K.Entertainment, gifts, and vacation
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.entertainment.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthEntertainment"
                              id="lastMonthEntertainment"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* L & M */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="transportation" md={12}>
                        l.Auto expenses and transportation(insurance, gas,
                        repairs, bus, etc.)
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.transportation.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthTransportation"
                              id="lastMonthTransportation"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="insurance" md={12}>
                        M.Insurance (life, accident, etc.; do not includeauto,
                        home, or health insurance).
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.insurance.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthInsurance"
                              id="lastMonthInsurance"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* N & O */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="savings" md={12}>
                        N.Savings and investments
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.savingsInvestments.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthSavings"
                              id="lastMonthSavings"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="charitable" md={12}>
                        O.Charitable contributions
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.charitableContributions.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthCharitable"
                              id="charitableCharitable"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* P & Q */}

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="monthlyPayments" md={12}>
                        P.Monthly payments listed in item 14(itemize below in 14
                        and insert total here)
                      </Label>
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.monthallyPayments.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthMonthlyPayments"
                              id="monthlyPaymentsMonthlyPayments"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Row>
                    <Col md={8}>
                      <Label for="monthallyExpenseOther" md={12}>
                        Q.Other{" "}
                      </Label>
                      <Input
                        defaultValue={props.others.specific}

                        type="text"
                        placeholder="Specify"
                        name="monthallyExpenseOther"
                        id="monthallyExpenseOther"
                      />
                    </Col>
                    <Col md={4}>
                      <Row>
                        <Col md={12}>
                          <InputGroup>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>$</InputGroupText>
                            </InputGroupAddon>
                            <Input
                              defaultValue={props.others.lastMonth}
                              type="number"
                              placeholder="Last Month"
                              name="lastMonthMonthallyExpenseOther"
                              id="lastMonthMonthallyExpenseOther"
                            ></Input>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>

            {/* R  */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="totalExpenses" md={12}>
                    <strong>TOTAL EXPENSES</strong>
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.totalExpense}
                          type="number"
                          placeholder="Amount"
                          name="lastMonthTotalExpenses"
                          id="lastMonthTotalExpenses"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* S */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="amountOfExpenses" md={12}>
                    <strong>Amount of expenses paid by others</strong>
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.amountPaidByOthers}
                          type="number"
                          placeholder="Amount"
                          name="lastMonthAmountOfExpenses"
                          id="lastMonthAmountOfExpenses"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <hr></hr>
          </div>
        );
      case 13:
        return (
          <div>
            {!isEmpty(inputFieldsInstallment) && inputFieldsInstallment.map((inputInstallment, index) => (
              <div key={index}>

                <Row>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <br></br>
                    <Label>Paid To:</Label>
                    <Input style={{ marginLeft: "2px" }} type="text" id="toPaymentInstallment"
                      onBlur={(e) => { handleChangeInputInstallment(index, e) }}
                      defaultValue={inputInstallment.toPaymentInstallment}
                    />
                  </Col>

                  <Col xl={6} lg={6} md={12} sm={12}>
                    <br></br>
                    <Label>For:</Label>
                    <Input type="text" id="forPaymentInstallment"
                      onBlur={(e) => { handleChangeInputInstallment(index, e) }}
                      defaultValue={inputInstallment.forPaymentInstallment}
                    />
                  </Col>

                </Row>

                <Row>

                  <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                    <br></br>
                    <Label>Amount:</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>$</InputGroupText>
                      </InputGroupAddon>
                      <Input type="number" id="amountInstallment"
                        onChange={(e) => { handleChangeInputInstallment(index, e) }}
                        defaultValue={inputInstallment.amountInstallment}
                      />
                    </InputGroup>
                  </Col>

                  <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                    <br></br>
                    <Label>Balance:</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>$</InputGroupText>
                      </InputGroupAddon>
                      <Input type="number" id="balanceInstallment"
                        onBlur={(e) => { handleChangeInputInstallment(index, e) }}
                        defaultValue={inputInstallment.balanceInstallment}
                      />
                    </InputGroup>
                  </Col>

                  <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                    <br></br>
                    <Label>Date of Last Payment:</Label>

                    <Input type="date" id="dateLastInstallment"
                      onChange={(e) => { handleChangeInputInstallment(index, e) }}
                      defaultValue={inputInstallment.dateLastInstallment == "1947-01-01" ? "" : inputInstallment.dateLastInstallment}
                    />
                  </Col>

                </Row>

                <Row>
                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <IconButton onClick={() => {handleRemoveFieldsInstallment(index); deleteInstallCall(index) }} style={{ float: "right", color: "black", marginTop: "15px" }} >
                      <RemoveIcon />
                    </IconButton>

                    {size(inputFieldsInstallment) < 6 && <IconButton onClick={() => handleAddFieldsInstallment()} style={{
                      float: "right", color: "black", marginTop: "15px",
                      pointerEvents: size(inputFieldsInstallment) < 6 ? 'all' : 'none'
                    }}>
                      <AddIcon />
                    </IconButton>}
                  </Col>
                </Row>
                <ColoredLine />
              </div>
            ))}
          </div>
        );
      case 14:
        return (
          <div>
            <FormGroup>
              <Label for="attorneyFee">
                Either party is requesting attorney fees?
              </Label>
              <Input
                defaultValue={props.attorneyFees.no}
                type="select"
                name="attorneyFee"
                id="attorneyFee"
                onChange={(e) => setIsRequesting(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  {" "}
                  -- select an option --{" "}
                </option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Input>
            </FormGroup>

            <Collapse isOpen={isRequesting == "1"}>
              <FormGroup>
                <Label for="dateAttorneyFeePaid">
                  A.To date, I have paid my attorney this amount for fees and
                  costs{" "}
                </Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.attorneyMonthallyFees.lastMonth}
                    type="number"
                    placeholder="Fee Pay"
                    name="dateAttorneyFeePaid"
                    id="dateAttorneyFeePaid"
                  ></Input>
                </InputGroup>
                <Label for="sourceOfMoney">B.The source of this money was</Label>

                <Input
                  defaultValue={props.sourceOfMoney}
                  type="text"
                  placeholder="Source Of Money"
                  name="sourceOfMoney"
                  id="sourceOfMoney"
                ></Input>
                <Label for="stillOwe">
                  C.I still owe the following fees and costs to my attorney
                  (specify total owed)
                </Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.totalOwedFee.lastMonth}
                    type="number"
                    placeholder="Still Owe"
                    name="stillOwe"
                    id="stillOwe"
                  ></Input>
                </InputGroup>
                <Label for="hourlyRate">D.My attorney's hourly rate is</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.attorneyHourlyRate.lastMonth}
                    type="number"
                    placeholder="My Attorney Hourly Rate"
                    name="hourlyRate"
                    id="hourlyRate"
                  ></Input>
                </InputGroup>
              </FormGroup>
            </Collapse>
          </div>
        );
      case 15:
        return (
          <div>
            <FormGroup>
              <Label for="numberOfChildren">
                Number of children under age 18 you have
              </Label>
              <Input
                defaultValue={props.NoOfChildren.NumberOfunderAgeChild}
                placeholder="Enter here"
                name="numberOfChildren"
                id="numberOfChildren"
              ></Input>

              <Row>
                <Col md={6}>
                  <Label for="timeWithYou">
                    Percent of time spend with you{" "}
                  </Label>
                  <Input
                    defaultValue={props.NoOfChildren.timeSpendWithYouPercentage}
                    placeholder="Enter time"
                    name="timeWithYou"
                    id="timeWithYou"
                  ></Input>
                </Col>

                <Col md={6}>
                  <Label for="timeWithOther">
                    Percent of time spend with Other Parent
                  </Label>
                  <Input
                    defaultValue={props.NoOfChildren.timeSpendWithSpousePercentage}
                    placeholder="Enter time"
                    name="timeWithOther"
                    id="timeWithOther"
                  ></Input>
                </Col>
              </Row>
            </FormGroup>
          </div>
        );
      case 16:
        return (
          <div>
            {" "}
            <FormGroup>
              <Label for="healthInsurance">Do you have health insurance?</Label>
              <Input
                defaultValue={props.childHealthCareExpense.no}
                type="select"
                name="healthInsurance"
                id="healthInsurance"
                onChange={(e) => setHealthInsurance(JSON.parse(e.target.value))}
              >
                <option selected value="-1">
                  {" "}
                  -- select an option --{" "}
                </option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Input>
            </FormGroup>
            <Collapse isOpen={healthInsurance == "1"}>
              <FormGroup>
                <Row>
                  <Col md={6}>
                    <Label for="insuranceCompany">
                      Name of insurance company
                    </Label>
                    <Input
                      defaultValue={props.insuranceCompanyName}

                      type="text"
                      name="insuranceCompany"
                      id="insuranceCompany"
                    ></Input>
                  </Col>

                  <Col md={6}>
                    <Label for="insuranceCompanyAddress">Address of insurance company</Label>
                    <Input
                      defaultValue={props.insuranceCompanyAddress}

                      type="text" name="insuranceCompanyAddress" id="insuranceCompanyAddress"></Input>
                  </Col>
                </Row>
                <Label for="monthlyCost">
                  The monthly cost for the children's health insurance is or
                  would be(Do not include the amount your employer pays)
                </Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>$</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    defaultValue={props.monthallyCost}
                    type="number" name="monthlyCost" id="monthlyCost"></Input>
                </InputGroup>
              </FormGroup>
            </Collapse>
          </div>
        );
      case 17:
        return (
          <div>
            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="childcare" md={12}>
                    A.Childcare so I can work or get job training
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.additionalChildExpense.childCare}
                          type="number"
                          placeholder="Amount Per Month"
                          name="lastChildCareExpense"
                          id="lastChildCareExpense"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* B */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="childrenHealth" md={12}>
                    B.Children's health care not covered by insurance{" "}
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.additionalChildExpense.childHealthCare}
                          type="number"
                          placeholder="Amount Per Month"
                          name="lastChildrenHealthAmount"
                          id="lastChildrenHealthAmount"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* C */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="travelExpenses" md={12}>
                    C.Travel expenses for visitation
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.additionalChildExpense.childTravelExpense}
                          type="number"
                          placeholder="Amount Per Month"
                          name="lastChildTravelExpenses"
                          id="lastChildTravelExpenses"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* D */}

            <FormGroup>
              <Row>
                <Col md={9}>
                  <Label for="educationalNeeds" md={12}>
                    D. Children's educational or other special needs{" "}
                  </Label>
                  <Input
                    defaultValue={props.childOtherSpecialNeeds.specific}
                    type="text"
                    placeholder="Specify"
                    name="educationalNeeds"
                    id="educationalNeeds"
                  ></Input>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.childOtherSpecialNeeds.lastMonth}
                          type="number"
                          placeholder="Amount Per Month"
                          name="MonthallyeducationalNeeds"
                          id="MonthallyeducationalNeeds"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
          </div>
        );
      case 18:
        return (
          <div>
            <p>
              I ask the court to consider the following special financial
              circumstances(attach documentation of any item listed here,
              including court orders)
            </p>

            {/* A */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="ExtraHealthExpenses" md={12}>
                    A.Extraordinary health expenses not included in 18b.
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.extraHealthExpenses.lastMonth}
                          type="number"
                          placeholder="Amount Per Month"
                          name="lastExtraHealthExpenses"
                          id="lastExtraHealthExpenses"
                        ></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <Input
                        defaultValue={props.extraHealthExpenses.averageMonthally}
                        placeholder="For How Many Months"
                        name="monthsForExtraHealthExpenses"
                        id="monthsForExtraHealthExpenses"
                      ></Input>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* B */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="majorLosses" md={12}>
                    B.Major losses not covered by insurance (examples: fire,
                    theft, other insured loss)
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.majorLoss.lastMonth}
                          type="number"
                          placeholder="Amount Per Month"
                          name="PerMonthMajorLosses"
                          id="PerMonthMajorLosses"
                        ></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <Input
                        defaultValue={props.majorLoss.averageMonthally}
                        type="number"
                        placeholder="For How Many Months"
                        name="howManyMonths"
                        id="monthForMajorLosses"
                      ></Input>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* C1 */}

            <FormGroup>
              <Row>
                <Col md={6}>
                  <Label for="minorChildExpenses" md={12}>
                    C. (1) Expenses for my minor children who are from other
                    relationships and are living with me
                  </Label>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={6}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.minorChildExpense.lastMonth}
                          type="number"
                          id="PerMinorChildExpenses"
                          placeholder="Amount Per Month"
                          name="PerMinorChildExpenses"
                        ></Input>
                      </InputGroup>
                    </Col>

                    <Col md={6}>
                      <InputGroup>

                        <Input
                          defaultValue={props.minorChildExpense.averageMonthally}
                          type="number"
                          placeholder="For How Many Months"
                          id="expenses"
                          name="monthForMinorChildExpenses"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* C2 */}

            <FormGroup style={{ marginLeft: "5%" }}>
              <Label>(2) Names and ages of those children</Label>
              <Input type="textarea" id="nameAndAges" placeholder="(specify)"
                defaultValue={props.childrenSpecify}>
              </Input>
            </FormGroup>


            {/* C3 */}

            <FormGroup style={{ marginLeft: "3%" }}>
              <Row>
                <Col md={9}>
                  <Label for="childSupport" md={12}>
                    (3) Child support I receive for those children
                  </Label>
                </Col>
                <Col md={3}>
                  <Row>
                    <Col md={12}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>$</InputGroupText>
                        </InputGroupAddon>
                        <Input
                          defaultValue={props.minorCS}
                          type="number"
                          placeholder="Amount Per Month"
                          name="monthallyChildSupport"
                          id="monthallyChildSupport"
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>

            {/* C4 */}

            <FormGroup>
              <Label for="extremeFinancialHardship">
                The expenses listed in a, b, and c create an extreme financial
                hardship because
              </Label>
              <Input
                defaultValue={props.financialHardshipExplain}
                type="textarea"
                name="extremeFinancialHardship"
                id="extremeFinancialHardship"
                placeholder="Explain"
              />
            </FormGroup>
          </div>
        );
      case 19:
        return (
          <div>
            <Input
              defaultValue={props.otherInfoForCourt}
              type="textarea"
              name="otherCourtInfo"
              id="otherCourtInfo"
              placeholder="Specify"
            />
          </div>
        );
      default:
        return "Unknown step";
    }
  }





  return (
    <div className={classes.root}>
      {props.isFecthingAllData || props.isFetchingDeletePeopleLive ?
        <div style={{ marginLeft: "42%", marginTop: "18%" }}>
          <Loader
            type="Puff"
            color="#00BFFF"
            height={120}
            width={120}
          />
        </div>
        :
        <div>
          <Stepper activeStep={activeStep} orientation="vertical"
            style={{
              fontStyle: "normal",
              fontFamily: "sans-serif",
              backgroundColor: "white",
              textAlign: "justify",
              textJustify: "inter-word",
              padding: "30px 70px"
            }}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index)}</Typography>
                  <div className={classes.actionsContainer}>

                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className={classes.button}
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      className={classes.button}
                    >
                      {activeStep === steps.length - 1 ? "Finish" : "Next"}
                    </Button>

                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <div>
                <Button style={{ backgroundColor: "red", color: "white" }} onClick={handleReset} className={classes.button}>
                  Reset
                </Button>
                <Button style={{ backgroundColor: "#3f51b5", color: "white" }} onClick={handleBack} className={classes.button}>
                  Back
                </Button>
              </div>
            </Paper>
          )}
          <Button
            style={{ float: "right" }}
            variant="contained"
            color="primary"
            onClick={myFunction}
          >
            Print Form
          </Button>
        </div>}
    </div>
  );

};

const mapStateToProps = (state) => ({

  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  court: state.ProfileInformationReducer.court,

  employement: state.AssestsDebitsReducer.employement,
  ageAndEducation: state.AssestsDebitsReducer.ageAndEducation,
  taxInData: state.AssestsDebitsReducer.taxInformation,
  otherPartyData: state.AssestsDebitsReducer.otherPartyIncome,

  incomeSalaryWages: state.AssestsDebitsReducer.income.salaryWages,
  incomeOverTime: state.AssestsDebitsReducer.income.overtime,
  incomeCommissions: state.AssestsDebitsReducer.income.commissions,
  incomePublicAssistance: state.AssestsDebitsReducer.income.publicAssistance,
  incomeSpousalSuport: state.AssestsDebitsReducer.income.spousalSuport,
  incomePartnerSupport: state.AssestsDebitsReducer.income.partnerSupport,
  incomeSocialSecurity: state.AssestsDebitsReducer.income.socialSecurity,
  incomePensionRetirementFund: state.AssestsDebitsReducer.income.pensionRetirementFund,
  incomeUnemploymentCompensation: state.AssestsDebitsReducer.income.unemploymentCompensation,
  incomeWorkerCompensation: state.AssestsDebitsReducer.income.WorkerCompensation,
  incomeOthers: state.AssestsDebitsReducer.income.others,
  incomeDisability: state.AssestsDebitsReducer.income.disability,



  dividendsInterest: state.AssestsDebitsReducer.investmentIncome.dividendsInterest,
  rentalPropertyIncome: state.AssestsDebitsReducer.investmentIncome.rentalPropertyIncome,
  workerCompensation: state.AssestsDebitsReducer.investmentIncome.trustIncome,
  trustIncome: state.AssestsDebitsReducer.investmentIncome.otherIncome,


  oneTimeMoney: state.AssestsDebitsReducer.oneTimeMoney,

  selfEmploymentType: state.AssestsDebitsReducer.IncomeFromSelfEmployment.selfEmployementType.selfEmployementTypeStatus,
  selfEmploymentSpecify: state.AssestsDebitsReducer.IncomeFromSelfEmployment.selfEmployementType.bussinessPartner.specify,
  selfEmploymentBusinessYears: state.AssestsDebitsReducer.IncomeFromSelfEmployment.yearsOfBusiness,
  selfEmploymentBusinessName: state.AssestsDebitsReducer.IncomeFromSelfEmployment.businessName,
  selfEmploymentBusinessType: state.AssestsDebitsReducer.IncomeFromSelfEmployment.businessType,



  changeInMoney: state.AssestsDebitsReducer.changeInIncome,

  requiredUnionDues: state.AssestsDebitsReducer.deductions.requiredUnionDues,
  requiredRetirementPay: state.AssestsDebitsReducer.deductions.requiredRetirementPay,
  healthExpenses: state.AssestsDebitsReducer.deductions.healthExpenses,
  childSupport: state.AssestsDebitsReducer.deductions.childSupport,
  spousalSupport: state.AssestsDebitsReducer.deductions.spousalSupport,
  partnerSupport: state.AssestsDebitsReducer.deductions.partnerSupport,
  jobExpenses: state.AssestsDebitsReducer.deductions.jobExpenses,




  accounts: state.AssestsDebitsReducer.assets.accounts,
  stockBonds: state.AssestsDebitsReducer.assets.stockBonds,
  otherPropert: state.AssestsDebitsReducer.assets.otherPropert,



  homeStatus: state.AssestsDebitsReducer.averageMonthallyExpenses.home.homeStatus,
  realPropertyTax: state.AssestsDebitsReducer.averageMonthallyExpenses.home.realPropertyTax,
  homeOwnerInsurance: state.AssestsDebitsReducer.averageMonthallyExpenses.home.homeOwnerInsurance,
  maintainance: state.AssestsDebitsReducer.averageMonthallyExpenses.home.maintainance,
  healthCareCost: state.AssestsDebitsReducer.averageMonthallyExpenses.healthCareCost,
  childCareCost: state.AssestsDebitsReducer.averageMonthallyExpenses.childCareCost,
  householdSupplies: state.AssestsDebitsReducer.averageMonthallyExpenses.householdSupplies,
  eatingOut: state.AssestsDebitsReducer.averageMonthallyExpenses.eatingOut,
  utilities: state.AssestsDebitsReducer.averageMonthallyExpenses.utilities,
  telephone: state.AssestsDebitsReducer.averageMonthallyExpenses.telephone,
  laundaryCleaning: state.AssestsDebitsReducer.averageMonthallyExpenses.laundaryCleaning,
  clothes: state.AssestsDebitsReducer.averageMonthallyExpenses.clothes,
  education: state.AssestsDebitsReducer.averageMonthallyExpenses.education,
  entertainment: state.AssestsDebitsReducer.averageMonthallyExpenses.entertainment,
  transportation: state.AssestsDebitsReducer.averageMonthallyExpenses.transportation,
  insurance: state.AssestsDebitsReducer.averageMonthallyExpenses.insurance,
  savingsInvestments: state.AssestsDebitsReducer.averageMonthallyExpenses.savingsInvestments,
  charitableContributions: state.AssestsDebitsReducer.averageMonthallyExpenses.charitableContributions,
  monthallyPayments: state.AssestsDebitsReducer.averageMonthallyExpenses.monthallyPayments,
  others: state.AssestsDebitsReducer.averageMonthallyExpenses.others,
  totalExpense: state.AssestsDebitsReducer.averageMonthallyExpenses.totalExpense,
  amountPaidByOthers: state.AssestsDebitsReducer.averageMonthallyExpenses.amountPaidByOthers,




  attorneyFees: state.AssestsDebitsReducer.attorneyFees,
  attorneyMonthallyFees: state.AssestsDebitsReducer.attorneyFees.yes.attorneyMonthallyFees,
  sourceOfMoney: state.AssestsDebitsReducer.attorneyFees.yes.sourceOfMoney,
  totalOwedFee: state.AssestsDebitsReducer.attorneyFees.yes.totalOwedFee,
  attorneyHourlyRate: state.AssestsDebitsReducer.attorneyFees.yes.attorneyHourlyRate,


  NoOfChildren: state.AssestsDebitsReducer.numberOfChildren,

  childHealthCareExpense: state.AssestsDebitsReducer.childHealthCareExpense,
  insuranceCompanyName: state.AssestsDebitsReducer.childHealthCareExpense.yes.insuranceCompanyName,
  insuranceCompanyAddress: state.AssestsDebitsReducer.childHealthCareExpense.yes.insuranceCompanyAddress,
  monthallyCost: state.AssestsDebitsReducer.childHealthCareExpense.yes.monthallyCost,



  additionalChildExpense: state.AssestsDebitsReducer.additionalChildExpense,
  childOtherSpecialNeeds: state.AssestsDebitsReducer.additionalChildExpense.childOtherSpecialNeeds,



  extraHealthExpenses: state.AssestsDebitsReducer.specialHardship.extraHealthExpenses,
  majorLoss: state.AssestsDebitsReducer.specialHardship.majorLoss,
  minorChildExpense: state.AssestsDebitsReducer.specialHardship.minorChildExpense,
  minorCS: state.AssestsDebitsReducer.specialHardship.minorChildSupport,
  financialHardshipExplain: state.AssestsDebitsReducer.specialHardship.financialHardshipExplain,
  childrenSpecify: state.AssestsDebitsReducer.specialHardship.childrenSpecify,

  otherInfoForCourt: state.AssestsDebitsReducer.otherInfoForCourt,
  isFecthingAllData: state.AssestsDebitsReducer.isFecthingAllData,

  petitionerCheck: state.ProfileInformationReducer.petitionerCheck,
  peopleLive: state.AssestsDebitsReducer.peopleLive,
  installmentPayments: state.AssestsDebitsReducer.installmentPayments,
  isFetchingDeletePeopleLive: state.AssestsDebitsReducer.isFetchingDeletePeopleLive,
  states: state.ProfileInformationReducer.states,

});

const mapDispatchToProps = (dispatch) => {
  return {

    allAssetDebitData: (data) => dispatch(allAssetDebitData(data)),
    postAssetDebitData: (data) => dispatch(postAssetDebitData(data)),
    employementDetails: (data) => dispatch(employementDetails(data)),
    ageEducation: (data) => dispatch(ageEducation(data)),
    taxInformation: (data) => dispatch(taxInformation(data)),
    otherPartyIncome: (data) => dispatch(otherPartyIncome(data)),
    income: (data) => dispatch(income(data)),
    investIncome: (data) => dispatch(investIncome(data)),
    additionalIncome: (data) => dispatch(additionalIncome(data)),
    selfEmployeedIncome: (data) => dispatch(selfEmployeedIncome(data)),
    changeInIncome: (data) => dispatch(changeInIncome(data)),
    deductions: (data) => dispatch(deductions(data)),
    asset: (data) => dispatch(asset(data)),
    averageMonthallyExpenset: (data) =>
      dispatch(averageMonthallyExpenset(data)),
    attorneyFee: (data) => dispatch(attorneyFee(data)),
    numberOfChildren: (data) => dispatch(numberOfChildren(data)),
    childHealthExpenses: (data) => dispatch(childHealthExpenses(data)),
    childAdditionalExpenses: (data) => dispatch(childAdditionalExpenses(data)),
    specialHardship: (data) => dispatch(specialHardship(data)),
    otherInformation: (data) => dispatch(otherInformation(data)),
    peopleLiveCall: (data) => dispatch(peopleLiveCall(data)),
    installmentPaymentsCall: (data) => dispatch(installmentPaymentsCall(data)),
    deletePeopleLiveCall: (data) => dispatch(deletePeopleLiveCall(data)),
    deleteInstallmentCall: (data) => dispatch(deleteInstallmentCall(data)),
    getStates: () => dispatch(getStates()),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssestsDebits);
